<template>
    <div>
        {{ getDropzoneUrl }}

        <div class="row">
            <div class="page-header">
                <div class="d-flex align-items-center">

                    <h2 class="page-header-title">
                        <router-link to="/">
                            Door Inspections</router-link>
                        &raquo;
                        <router-link :to="{ name: 'door-check-view', params: {action: 'view', id: doorCheck.site_door_check_id} }">
                            {{ doorCheck.document_id }} | {{ doorCheck.document_title }}
                        </router-link>
                        &raquo;
                        <span v-if="isEdit">Edit Door</span><span v-else>Add new Door</span></h2>
                </div>
            </div>
        </div>

        <form @submit.prevent="submit">
            <div class="form-body">
                <div style="display:none;">
                    <div class="col-lg-6 col-md-12"><input type="hidden" name="_method" value="POST"/></div>
                </div>
                <div class="form-body">
                    <input
                            name="site_door_check_id"
                            type="hidden"
                            v-model="doorCheckDoor.site_door_check_id"
                    >
                    <input
                            name="site_door_check_door_id"
                            type="hidden"
                            v-model="doorCheckDoor.site_door_check_door_id"
                    >
                    <div class="row">
                        <div class="col-sm-12 widget-20">

                            <div class="widget has-shadow" v-if="dbName !== 'jpfire'">
                                <div class="widget-header bordered d-flex align-items-center section-header">
                                    <h2>Door Location</h2>
                                </div>
                                <div class="widget-body">
                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('site_door_check_site_plan_id')]"
                                                for="site_door_check_site_plan_id">
                                            Site Plan
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <select
                                                    name="site_door_check_site_plan_id"
                                                    id="site_door_check_site_plan_id"
                                                    :class="['form-control', getFieldClasses('site_door_check_site_plan_id')]"
                                                    v-model="doorCheckDoor.site_door_check_site_plan_id"
                                                    @blur="onFieldBlur('site_door_check_site_plan_id')"
                                            >
                                                <option value="">Please select an option</option>
                                                <option v-bind:value="sitePlan.site_door_check_site_plan_id" v-for="sitePlan in sitePlans" v-bind:key="sitePlan.site_door_check_site_plan_id">{{ sitePlan.site_plan_title }}</option>
                                            </select>
                                            <div v-if="isErrorField('site_door_check_site_plan_id')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>
            
                                    <div class="form-group" v-if="selectedSitePlanImg">
                                        <site-plan-marker
                                            v-bind:markerPosition="sitePlanMarkerData"
                                            v-bind:markerNumber="doorCheckDoor.pin_number"
                                            v-bind:imgData="selectedSitePlanImg"
                                            @update-marker="updateMarker"
                                            ref="sitePlanComp"
                                        ></site-plan-marker>
                                    </div>
                                    <div v-if="isErrorField('site_plan_image_position_x')" class="invalid-feedback">Please place marker on the site plan or clear the selection</div>
                                </div>
                            </div>

                            <div class="widget has-shadow">
                                <div class="widget-header bordered d-flex align-items-center section-header">
                                    <h2>Door Details</h2>
                                </div>
                                <div class="widget-body">

                                    <div class="col-lg-6 col-md-12">
                                        <input
                                                name="door_check_id"
                                                id="door-check-id"
                                                type="hidden"
                                                v-model="doorCheckDoor.door_check_id"
                                        />
                                    </div>

                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('door_id')]"
                                                for="door-id">
                                            Door ID
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    name="door_id"
                                                    id="door-id"
                                                    :class="['form-control', getFieldClasses('door_id')]"
                                                    v-model="doorCheckDoor.door_id"
                                                    maxlength="255"
                                                    class="form-control"
                                                    ref="first"
                                                    type="text"
                                                    @blur="onFieldBlur('door_id')"
                                            />
                                            <div v-if="isErrorField('door_id')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                v-if="dbName !== 'jpfire' && dbName !== 'qfpc'"
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('barcode')]"
                                                for="barcode">
                                            Identifier
                                        </label>
                                        <label
                                                v-else
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('barcode')]"
                                                for="barcode">
                                            Barcode
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    name="barcode"
                                                    id="barcode"
                                                    :class="['form-control', getFieldClasses('barcode')]"
                                                    v-model="doorCheckDoor.barcode"
                                                    type="text"
                                                    maxlength="255"
                                                    class="form-control"
                                                    @blur="onFieldBlur('barcode')"
                                            />
                                            <div v-if="isErrorField('barcode')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center" v-if="dbName !== 'jpfire' && dbName !== 'qfpc'">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('door_status')]"
                                                for="door_status">
                                            Status
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <select
                                                    name="door_status"
                                                    id="door_status"
                                                    :class="['form-control', getFieldClasses('door_status')]"
                                                    v-model="doorCheckDoor.door_status"
                                                    @blur="onFieldBlur('door_status')"
                                            >
                                                <option value="" disabled="disabled">Please select an option</option>
                                                <option v-bind:value="status" v-for="status in doorStatuses" v-bind:key="status">{{ status }}</option>
                                            </select>
                                            <div v-if="isErrorField('door_status')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center" v-if="dbName !== 'jpfire' && dbName !== 'qfpc'">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('door_type')]"
                                                for="client_defined_rating">
                                            Client Defined Rating
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <select
                                                    name="client_defined_rating"
                                                    id="client_defined_rating"
                                                    :class="['form-control', getFieldClasses('client_defined_rating')]"
                                                    v-model="doorCheckDoor.client_defined_rating"
                                                    @blur="onFieldBlur('client_defined_rating')"
                                            >
                                                <option value="" disabled="disabled">Please select an option</option>
                                                <option v-bind:value="clientDefinedRating.client_defined_rating_name" v-for="clientDefinedRating in clientDefinedRatings" v-bind:key="clientDefinedRating.client_defined_rating_id">{{ clientDefinedRating.client_defined_rating_name }}</option>
                                            </select>
                                            <div v-if="isErrorField('client_defined_rating')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('door_type')]"
                                                for="door-type">
                                            Door Type
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <select
                                                    name="door_type"
                                                    id="door-type"
                                                    :class="['form-control', getFieldClasses('door_type')]"
                                                    v-model="doorCheckDoor.door_type"
                                                    @blur="onFieldBlur('door_type')"
                                            >
                                                <option value="" disabled="disabled">Please select an option</option>
                                                <option v-bind:value="doorTypeOption.door_type_name" v-for="doorTypeOption in doorTypes" v-bind:key="doorTypeOption.door_type_id">{{ doorTypeOption.door_type_name }}</option>
                                            </select>
                                            <div v-if="isErrorField('door_type')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center">
                                        <label
                                                v-if="dbName !== 'jpfire' && dbName !== 'qfpc'"
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('door_location')]"
                                                for="door-location">
                                            Floor Level
                                        </label>
                                        <label
                                                v-else
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('door_location')]"
                                                for="door-location">
                                            Door Location
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <select
                                                    name="door_location"
                                                    id="door-location"
                                                    :class="['form-control', getFieldClasses('door_location')]"
                                                    v-model="doorCheckDoor.door_location"
                                                    @blur="onFieldBlur('door_location')"
                                            >
                                                <option disabled="disabled" value="">Please select an option</option>
                                                <option v-bind:value="location.location_name" v-for="location in locations" v-bind:key="location.location_id">{{ location.location_name }}</option>
                                                <option value=" ">Other, please specify</option>
                                            </select>
                                            <div v-if="isErrorField('door_location')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div v-if="doorCheckDoor.door_location !== '' && locationNamesArray.indexOf(doorCheckDoor.door_location) === -1">
                                        <div class="form-group row d-flex align-items-center d-none">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end" for="door-location-override">
                                                Specify <span v-if="dbName !== 'jpfire' && dbName !== 'qfpc'">Floor Level</span><span v-else>Door Location</span>
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <input
                                                        name="door_location_override"
                                                        id="door-location-override"
                                                        :class="['form-control', { 'has-error': submitting }]"
                                                        v-model="doorCheckDoor.door_location"
                                                        type="text"
                                                >
                                                <div v-if="isErrorField('door_location')" class="invalid-feedback">This field is required</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center" v-if="!doorCheck.is_third_party_report">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('door_material')]"
                                                for="door-material">
                                            Door Material
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <select
                                                    name="door_material"
                                                    id="door-material"
                                                    :class="['form-control', getFieldClasses('door_material')]"
                                                    v-model="doorCheckDoor.door_material"
                                                    @blur="onFieldBlur('door_material')"
                                            >
                                                <option value="" disabled="disabled">Please select an option</option>
                                                <option v-bind:value="doorMaterial.material_name" v-for="doorMaterial in doorMaterials" v-bind:key="doorMaterial.door_material_id">{{ doorMaterial.material_name }}</option>
                                            </select>
                                            <div v-if="isErrorField('door_material')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center " v-if="!doorCheck.is_third_party_report">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('frame_material')]"
                                                for="frame-material">
                                            Frame Material
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <select
                                                    name="frame_material"
                                                    id="frame-material"
                                                    :class="['form-control', getFieldClasses('frame_material')]"
                                                    v-model="doorCheckDoor.frame_material"
                                                    @blur="onFieldBlur('frame_material')"
                                            >
                                                <option value="" disabled="disabled">Please select an option</option>
                                                <option v-bind:value="frameMaterial.material_name" v-for="frameMaterial in frameMaterials" v-bind:key="frameMaterial.frame_material_id">{{ frameMaterial.material_name }}</option>
                                            </select>
                                            <div v-if="isErrorField('frame_material')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center" v-if="dbName !== 'jpfire' && doorCheck.use_bm_trada_template">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('declared_resistance_level')]"
                                                for="declared_resistance_level">
                                            Client Declared Resistance Level
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <select
                                                    name="declared_resistance_level"
                                                    id="declared_resistance_level"
                                                    :class="['form-control', getFieldClasses('declared_resistance_level')]"
                                                    v-model="doorCheckDoor.declared_resistance_level"
                                                    @blur="onFieldBlur('declared_resistance_level')"
                                            >
                                                <option value="" disabled="disabled">Please select an option</option>
                                                <option v-bind:value="declaredResistanceLevel.declared_resistance_level_title" v-for="declaredResistanceLevel in declaredResistanceLevels" v-bind:key="declaredResistanceLevel.declared_resistance_level_id">{{ declaredResistanceLevel.declared_resistance_level_title }}</option>
                                            </select>
                                            <div v-if="isErrorField('declared_resistance_level')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center" v-if="dbName !== 'jpfire' && doorCheck.use_bm_trada_template && !doorCheck.is_third_party_report">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('level')]"
                                                for="level">
                                            Level
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <select
                                                    name="level"
                                                    id="level"
                                                    :class="['form-control', getFieldClasses('level')]"
                                                    v-model="doorCheckDoor.level"
                                                    @blur="onFieldBlur('level')"
                                            >
                                                <option value="" disabled="disabled">Please select an option</option>
                                                <option v-bind:value="levelOption.level_option_title" v-for="levelOption in levelOptions" v-bind:key="levelOption.level_option_id">{{ levelOption.level_option_title }}</option>
                                            </select>
                                            <div v-if="isErrorField('level')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center" v-if="dbName !== 'jpfire' && doorCheck.use_bm_trada_template && !doorCheck.is_third_party_report">
                                        <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            <label>Plugs & Labels Present</label>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="radio-as-buttons">
                                                <li style="width: 45%">
                                                    <input type="radio"
                                                           :value="true"
                                                           id="plp-yes"
                                                           name="plugs_labels_present"
                                                           class="button-positive"
                                                           v-model="doorCheckDoor.plugs_labels_present"
                                                    >
                                                    <label for="plp-yes">Yes</label>
                                                </li>
                                                <li style="width: 45%">
                                                    <input type="radio"
                                                           :value="false"
                                                           id="plp-no"
                                                           name="plugs_labels_present"
                                                           class="button-negative"
                                                           v-model="doorCheckDoor.plugs_labels_present"
                                                    >
                                                    <label for="plp-no">No</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center" v-if="dbName !== 'jpfire' && doorCheck.use_bm_trada_template">
                                        <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            <label>Test Evidence Available</label>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="radio-as-buttons">
                                                <li style="width: 45%">
                                                    <input type="radio"
                                                           :value="true"
                                                           id="tea-yes"
                                                           name="test_evidence_available"
                                                           class="button-positive"
                                                           v-model="doorCheckDoor.test_evidence_available"
                                                    >
                                                    <label for="tea-yes">Yes</label>
                                                </li>
                                                <li style="width: 45%">
                                                    <input type="radio"
                                                           :value="false"
                                                           id="tea-no"
                                                           name="test_evidence_available"
                                                           class="button-negative"
                                                           v-model="doorCheckDoor.test_evidence_available"
                                                    >
                                                    <label for="tea-no">No</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center" v-if="!doorCheck.is_third_party_report">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('door_set')]"
                                                for="door-set">
                                            Door Set
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <select
                                                    name="door_set"
                                                    id="door-set"
                                                    :class="['form-control', getFieldClasses('door_set')]"
                                                    v-model="doorCheckDoor.door_set"
                                                    @blur="onFieldBlur('door_set')"
                                                    @change="onDoorSetChanged()"
                                            >
                                                <option value="" disabled="disabled">Please select an option</option>
                                                <option v-bind:value="doorSet.door_set_name" v-for="doorSet in doorSets" v-bind:key="doorSet.door_set_id">{{ doorSet.door_set_name }}</option>
                                            </select>
                                            <div v-if="isErrorField('door_set')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center" v-if="!doorCheck.is_third_party_report">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('dimensions')]"
                                                for="dimensions">
                                            Dimensions
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    name="dimensions"
                                                    id="dimensions"
                                                    :class="['form-control', getFieldClasses('dimensions')]"
                                                    v-model="doorCheckDoor.dimensions"
                                                    type="text"
                                                    maxlength="255"
                                                    @blur="onFieldBlur('dimensions')"
                                            />
                                            <div v-if="isErrorField('dimensions')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center required" v-if="!doorCheck.is_third_party_report">
                                        <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            <label>Glazing panels?</label>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="radio-as-buttons">
                                                <li style="width: 45%">
                                                    <input type="radio"
                                                           :value="true"
                                                           id="gp-yes"
                                                           name="glazing_panels"
                                                           class="button-positive"
                                                           v-model="doorCheckDoor.glazing_panels"
                                                    >
                                                    <label for="gp-yes">Yes</label>
                                                </li>
                                                <li style="width: 45%">
                                                    <input type="radio"
                                                           :value="false"
                                                           id="gp-no"
                                                           name="glazing_panels"
                                                           class="button-negative"
                                                           v-model="doorCheckDoor.glazing_panels"
                                                    >
                                                    <label for="gp-no">No</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div v-if="doorCheckDoor.glazing_panels && !doorCheck.is_third_party_report">
                                        <div class="form-group row d-flex align-items-center">
                                            <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('glazing_panels_number')]"
                                                for="glazing-panels-number">
                                                Glazing Panels Number
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <input
                                                        name="glazing_panels_number"
                                                        id="glazing-panels-number"
                                                        :class="['form-control', getFieldClasses('glazing_panels_number')]"
                                                        v-model="doorCheckDoor.glazing_panels_number"
                                                        type="text"
                                                        maxlength="60"
                                                        @blur="onFieldBlur('glazing_panels_number')"
                                                >
                                                <div v-if="isErrorField('glazing_panels_number')" class="invalid-feedback">This field is required</div>
                                            </div>
                                        </div>
                                        <div class="form-group row d-flex align-items-center">
                                            <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('glazing_panels_sizes')]"
                                                for="glazing-panels-sizes">
                                                Glazing Panels Sizes
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <input
                                                        name="glazing_panels_sizes"
                                                        id="glazing-panels-sizes"
                                                        :class="['form-control', getFieldClasses('glazing_panels_sizes')]"
                                                        v-model="doorCheckDoor.glazing_panels_sizes"
                                                        type="text"
                                                        maxlength="60"
                                                        @blur="onFieldBlur('glazing_panels_sizes')"
                                                >
                                                <div v-if="isErrorField('glazing_panels_sizes')" class="invalid-feedback">This field is required</div>
                                            </div>
                                        </div>
                                        <div class="form-group row d-flex align-items-center" v-if="dbName !== 'jpfire'">
                                            <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('glazing_panels_type')]"
                                                for="glazing-panels-type">
                                                Glazing Panels Type
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <input
                                                        name="glazing_panels_type"
                                                        id="glazing-panels-type"
                                                        :class="['form-control', getFieldClasses('glazing_panels_type')]"
                                                        v-model="doorCheckDoor.glazing_panels_type"
                                                        type="text"
                                                        maxlength="60"
                                                        @blur="onFieldBlur('glazing_panels_type')"
                                                >
                                                <div v-if="isErrorField('glazing_panels_type')" class="invalid-feedback">This field is required</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center" v-if="!doorCheck.is_third_party_report">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('substrate_type')]"
                                                for="substrate-type">
                                            Substrate Type
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <select
                                                    name="substrate_type"
                                                    id="substrate-type"
                                                    :class="['form-control', getFieldClasses('substrate_type')]"
                                                    v-model="doorCheckDoor.substrate_type"
                                                    @blur="onFieldBlur('substrate_type')"
                                            >
                                                <option disabled="disabled" value="">Please select an option</option>
                                                <option v-bind:value="substrateType.substrate_type_name" v-for="substrateType in substrateTypes" v-bind:key="substrateType.substrate_type_id">{{ substrateType.substrate_type_name }}</option>
                                                <option value=" ">Other, please specify</option>
                                            </select>
                                            <div v-if="isErrorField('substrate_type')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div v-if="doorCheckDoor.substrate_type !== '' && substrateTypeNamesArray.indexOf(doorCheckDoor.substrate_type) === -1 && !doorCheck.is_third_party_report">
                                        <div class="form-group row d-flex align-items-center d-none">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end" for="substrate-type-override">
                                                Specify Substrate Type
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <input
                                                        name="substrate_type_override"
                                                        id="substrate-type-override"
                                                        :class="['form-control', { 'has-error': submitting }]"
                                                        v-model="doorCheckDoor.substrate_type"
                                                        type="text"
                                                        maxlength="60"
                                                >
                                                <div v-if="isErrorField('substrate_type')" class="invalid-feedback">This field is required</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center" v-if="dbName !== 'jpfire' && dbName !== 'qfpc'">
                                        <label 
                                        :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('door_inspected_by')]"
                                            for="door_inspected_by">
                                            Door Inspected By
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    name="door_inspected_by"
                                                    id="door_inspected_by"
                                                    :class="['form-control', getFieldClasses('door_inspected_by')]"
                                                    v-model="doorCheckDoor.door_inspected_by"
                                                    type="text"
                                                    maxlength="255"
                                            >
                                            <div v-if="isErrorField('door_inspected_by')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center mt-2 required border-top" v-if="!doorCheck.is_third_party_report">
                                        <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            <p><strong>Mark all as:</strong></p>
                                        </div>
                                        <div class="col-lg-6">
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="1"
                                                           id="question-1-pass"
                                                           name="mark-all"
                                                           class="mark-all-answers-selector template-option--radio-as-button__pass"
                                                           v-on:click="markAllAsPass"
                                                    >
                                                    <label for="question-1-pass"
                                                           style="font-weight: bold;">Pass</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="2"
                                                           id="question-2-na"
                                                           name="mark-all"
                                                           class="mark-all-answers-selector template-option--radio-as-button__na"
                                                           v-on:click="markAllAsNa"
                                                    >
                                                    <label for="question-2-na"
                                                           style="font-weight: bold;">N/A</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="3"
                                                           id="question-3-fail"
                                                           name="mark-all"
                                                           class="mark-all-answers-selector template-option--radio-as-button__fail"
                                                           v-on:click="markAllAsFail"
                                                    >
                                                    <label for="question-3-fail"
                                                           style="font-weight: bold;">Fail</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>


                                    <div class="form-group row d-flex align-items-center required" v-if="!doorCheck.is_third_party_report">
                                        <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            <label :class="[getContainerClasses('frame_pass_status')]">
                                                Frame Passed?</label>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Pass" id="frame-pass-status-pass"
                                                           name="frame_pass_status"
                                                           v-model="doorCheckDoor.frame_pass_status"
                                                           class="door-pass-status question-option--radio-as-button__1 template-option--radio-as-button__pass toggle-hidden-questions-container--close door-pass-status__pass"
                                                    >
                                                    <label for="frame-pass-status-pass">Pass</label>
                                                </li>

                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="frame-pass-status-na"
                                                           name="frame_pass_status"
                                                           v-model="doorCheckDoor.frame_pass_status"
                                                           class="door-pass-status question-option--radio-as-button__2 template-option--radio-as-button__na toggle-hidden-questions-container--close door-pass-status__na"
                                                    >
                                                    <label for="frame-pass-status-na">N/A</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="Fail" id="frame-pass-status-fail"
                                                           name="frame_pass_status"
                                                           v-model="doorCheckDoor.frame_pass_status"
                                                           class="door-pass-status question-option--radio-as-button__3 template-option--radio-as-button__fail toggle-hidden-questions-container--open door-pass-status__fail"
                                                    >
                                                    <label for="frame-pass-status-fail">Fail</label>
                                                </li>
                                            </ul>
                                        </div>

                                    </div>

                                    <div v-if="doorCheckDoor.frame_pass_status === 'Fail' && !doorCheck.is_third_party_report">
                                        <div class="form-group row d-flex align-items-center " v-if="frameFaults.length > 0">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end"
                                                   for="frame-pass-faults">Select faults</label>
                                            <div class="col-lg-6 col-md-12">
                                                <multiselect
                                                        :searchable="false"
                                                        :close-on-select="false"
                                                        v-model="doorCheckDoor.frame_faults"
                                                        :options="frameFaults"
                                                        label="fault_description"
                                                        track-by="door_fault_id"
                                                        :multiple="true"
                                                ></multiselect>
                                            </div>
                                        </div>
                                        <div class="form-group row d-flex align-items-center" v-if="doorCheckDoor.frame_faults && doorCheckDoor.frame_faults.length > 0">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end">Door Frame Faults Qty</label>
                                            <div class="col-lg-8">
                                                <div class="form-group row d-flex align-items-center " v-for="faultItem in doorCheckDoor.frame_faults" :key="'doorFault'+faultItem.door_fault_id">
                                                    <label class="form-control-label door-fault-label"
                                                        v-bind:for="'qty_'+faultItem.door_fault_id">{{ faultItem.fault_description }}</label>
                                                    <div class="col-md-12">
                                                        <input
                                                                v-model="faultItem.qty"
                                                                v-bind:id="'qty_'+faultItem.door_fault_id"
                                                                class="form-control"
                                                                type="number"
                                                                min="0"
                                                                step="1"
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group row d-flex align-items-center">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end"
                                                   for="frame-pass-additional-comments">Any additional comments</label>
                                            <div class="col-lg-6 col-md-12">
                                        <textarea class="form-control" name="frame_pass_additional_comments"
                                                  v-model="doorCheckDoor.frame_pass_additional_comments"
                                                  id="frame-pass-additional-comments" rows="5"></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center required" v-if="!doorCheck.is_third_party_report">
                                        <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            <label :class="[getContainerClasses('hinge_pass_status')]">Hinge Passed?</label>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="radio-as-buttons">

                                                <li class="template-option--li">
                                                    <input type="radio" value="Pass" id="hinge-pass-status-pass"
                                                           name="hinge_pass_status"
                                                           v-model="doorCheckDoor.hinge_pass_status"
                                                           class="door-pass-status question-option--radio-as-button__1 template-option--radio-as-button__pass toggle-hidden-questions-container--close door-pass-status__pass"
                                                    >
                                                    <label for="hinge-pass-status-pass">Pass</label>
                                                </li>

                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="hinge-pass-status-na"
                                                           name="hinge_pass_status"
                                                           v-model="doorCheckDoor.hinge_pass_status"
                                                           class="door-pass-status question-option--radio-as-button__2 template-option--radio-as-button__na toggle-hidden-questions-container--close door-pass-status__na"
                                                    >
                                                    <label for="hinge-pass-status-na">N/A</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="Fail" id="hinge-pass-status-fail"
                                                           name="hinge_pass_status"
                                                           v-model="doorCheckDoor.hinge_pass_status"
                                                           class="door-pass-status question-option--radio-as-button__3 template-option--radio-as-button__fail toggle-hidden-questions-container--open door-pass-status__fail"
                                                    >
                                                    <label for="hinge-pass-status-fail">Fail</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div v-if="doorCheckDoor.hinge_pass_status === 'Fail' && !doorCheck.is_third_party_report">
                                        <div class="form-group row d-flex align-items-center " v-if="hingeFaults.length > 0">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end"
                                                   for="hinge-pass-faults">Select faults</label>
                                            <div class="col-lg-6 col-md-12">
                                                <multiselect
                                                        :searchable="false"
                                                        :close-on-select="false"
                                                        v-model="doorCheckDoor.hinge_faults"
                                                        :options="hingeFaults"
                                                        label="fault_description"
                                                        track-by="door_fault_id"
                                                        :multiple="true"
                                                ></multiselect>
                                            </div>
                                        </div>
                                        <div class="form-group row d-flex align-items-center" v-if="doorCheckDoor.hinge_faults && doorCheckDoor.hinge_faults.length > 0">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end">Hinge Faults Qty</label>
                                            <div class="col-lg-8">
                                                <div class="form-group row d-flex align-items-center " v-for="faultItem in doorCheckDoor.hinge_faults" :key="'doorFault'+faultItem.door_fault_id">
                                                    <label class="form-control-label door-fault-label"
                                                    v-bind:for="'qty_'+faultItem.door_fault_id">{{ faultItem.fault_description }}</label>
                                                    <div class="col-md-12">
                                                        <input
                                                                v-model="faultItem.qty"
                                                                v-bind:id="'qty_'+faultItem.door_fault_id"
                                                                class="form-control"
                                                                type="number"
                                                                min="0"
                                                                step="1"
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group row d-flex align-items-center">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end"
                                                   for="hinge-pass-additional-comments">Any additional comments</label>
                                            <div class="col-lg-6 col-md-12">
                                        <textarea class="form-control" name="hinge_pass_additional_comments"
                                                  v-model="doorCheckDoor.hinge_pass_additional_comments"
                                                  id="hinge-pass-additional-comments" rows="5"></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center required" v-if="!doorCheck.is_third_party_report">
                                        <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            <label :class="[getContainerClasses('lock_pass_status')]">Lock Passed?</label>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Pass" id="lock-pass-status-pass"
                                                           name="lock_pass_status"
                                                           v-model="doorCheckDoor.lock_pass_status"
                                                           class="door-pass-status question-option--radio-as-button__1 template-option--radio-as-button__pass toggle-hidden-questions-container--close door-pass-status__pass"
                                                    >
                                                    <label for="lock-pass-status-pass">Pass</label>
                                                </li>

                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="lock-pass-status-na"
                                                           name="lock_pass_status"
                                                           v-model="doorCheckDoor.lock_pass_status"
                                                           class="door-pass-status question-option--radio-as-button__2 template-option--radio-as-button__na toggle-hidden-questions-container--close door-pass-status__na"
                                                    >
                                                    <label for="lock-pass-status-na">N/A</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="Fail" id="lock-pass-status-fail"
                                                           name="lock_pass_status"
                                                           v-model="doorCheckDoor.lock_pass_status"
                                                           class="door-pass-status question-option--radio-as-button__3 template-option--radio-as-button__fail toggle-hidden-questions-container--open door-pass-status__fail"
                                                    >
                                                    <label for="lock-pass-status-fail">Fail</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div v-if="doorCheckDoor.lock_pass_status === 'Fail' && !doorCheck.is_third_party_report">
                                        <div class="form-group row d-flex align-items-center " v-if="lockFaults.length > 0">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end"
                                                   for="lock-pass-faults">Select faults</label>
                                            <div class="col-lg-6 col-md-12">
                                                <multiselect
                                                        :searchable="false"
                                                        :close-on-select="false"
                                                        v-model="doorCheckDoor.lock_faults"
                                                        :options="lockFaults"
                                                        label="fault_description"
                                                        track-by="door_fault_id"
                                                        :multiple="true"
                                                ></multiselect>
                                            </div>
                                        </div>
                                        <div class="form-group row d-flex align-items-center" v-if="doorCheckDoor.lock_faults && doorCheckDoor.lock_faults.length > 0">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end">Lock Faults Qty</label>
                                            <div class="col-lg-8">
                                                <div class="form-group row d-flex align-items-center " v-for="faultItem in doorCheckDoor.lock_faults" :key="'doorFault'+faultItem.door_fault_id">
                                                    <label class="form-control-label door-fault-label"
                                                    v-bind:for="'qty_'+faultItem.door_fault_id">{{ faultItem.fault_description }}</label>
                                                    <div class="col-md-12">
                                                        <input
                                                                v-model="faultItem.qty"
                                                                v-bind:id="'qty_'+faultItem.door_fault_id"
                                                                class="form-control"
                                                                type="number"
                                                                min="0"
                                                                step="1"
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group row d-flex align-items-center">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end"
                                                   for="lock-pass-additional-comments">Any additional comments</label>
                                            <div class="col-lg-6 col-md-12">
                                        <textarea class="form-control" name="lock_pass_additional_comments"
                                                  v-model="doorCheckDoor.lock_pass_additional_comments"
                                                  id="lock-pass-additional-comments" rows="5"></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center required" v-if="!doorCheck.is_third_party_report">
                                        <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            <label :class="[getContainerClasses('glass_pass_status')]">Glass Passed?</label>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Pass" id="glass-pass-status-pass"
                                                           name="glass_pass_status"
                                                           v-model="doorCheckDoor.glass_pass_status"
                                                           class="door-pass-status question-option--radio-as-button__1 template-option--radio-as-button__pass toggle-hidden-questions-container--close door-pass-status__pass"
                                                    >
                                                    <label for="glass-pass-status-pass">Pass</label>
                                                </li>

                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="glass-pass-status-na"
                                                           name="glass_pass_status"
                                                           v-model="doorCheckDoor.glass_pass_status"
                                                           class="door-pass-status question-option--radio-as-button__2 template-option--radio-as-button__na toggle-hidden-questions-container--close door-pass-status__na"
                                                    >
                                                    <label for="glass-pass-status-na">N/A</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="Fail" id="glass-pass-status-fail"
                                                           name="glass_pass_status"
                                                           v-model="doorCheckDoor.glass_pass_status"
                                                           class="door-pass-status question-option--radio-as-button__3 template-option--radio-as-button__fail toggle-hidden-questions-container--open door-pass-status__fail"
                                                    >
                                                    <label for="glass-pass-status-fail">Fail</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div v-if="doorCheckDoor.glass_pass_status === 'Fail' && !doorCheck.is_third_party_report">
                                        <div class="form-group row d-flex align-items-center ">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end"
                                                   for="glass-pass-faults">Select faults</label>
                                            <div class="col-lg-6 col-md-12">
                                                <multiselect
                                                        :searchable="false"
                                                        :close-on-select="false"
                                                        v-model="doorCheckDoor.glass_faults"
                                                        :options="glassFaults"
                                                        label="fault_description"
                                                        track-by="door_fault_id"
                                                        :multiple="true"
                                                ></multiselect>
                                            </div>
                                        </div>
                                        <div class="form-group row d-flex align-items-center" v-if="doorCheckDoor.glass_faults && doorCheckDoor.glass_faults.length > 0">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end">Glass Faults Qty</label>
                                            <div class="col-lg-8">
                                                <div class="form-group row d-flex align-items-center " v-for="faultItem in doorCheckDoor.glass_faults" :key="'doorFault'+faultItem.door_fault_id">
                                                    <label class="form-control-label door-fault-label"
                                                    v-bind:for="'qty_'+faultItem.door_fault_id">{{ faultItem.fault_description }}</label>
                                                    <div class="col-md-12">
                                                        <input
                                                                v-model="faultItem.qty"
                                                                v-bind:id="'qty_'+faultItem.door_fault_id"
                                                                class="form-control"
                                                                type="number"
                                                                min="0"
                                                                step="1"
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group row d-flex align-items-center">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end"
                                                   for="glass-pass-additional-comments">Any additional comments</label>
                                            <div class="col-lg-6 col-md-12">
                                        <textarea class="form-control" name="glass_pass_additional_comments"
                                                  v-model="doorCheckDoor.glass_pass_additional_comments"
                                                  id="glass-pass-additional-comments" rows="5"></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center required" v-if="!doorCheck.is_third_party_report">
                                        <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            <label :class="[getContainerClasses('seals_pass_status')]">Seals Passed?</label>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Pass" id="seals-pass-status-pass"
                                                           name="seals_pass_status"
                                                           v-model="doorCheckDoor.seals_pass_status"
                                                           class="door-pass-status question-option--radio-as-button__1 template-option--radio-as-button__pass toggle-hidden-questions-container--close door-pass-status__pass"
                                                    >
                                                    <label for="seals-pass-status-pass">Pass</label>
                                                </li>

                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="seals-pass-status-na"
                                                           name="seals_pass_status"
                                                           v-model="doorCheckDoor.seals_pass_status"
                                                           class="door-pass-status question-option--radio-as-button__2 template-option--radio-as-button__na toggle-hidden-questions-container--close door-pass-status__na"
                                                    >
                                                    <label for="seals-pass-status-na">N/A</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="Fail" id="seals-pass-status-fail"
                                                           name="seals_pass_status"
                                                           v-model="doorCheckDoor.seals_pass_status"
                                                           class="door-pass-status question-option--radio-as-button__3 template-option--radio-as-button__fail toggle-hidden-questions-container--open door-pass-status__fail"
                                                    >
                                                    <label for="seals-pass-status-fail">Fail</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div v-if="doorCheckDoor.seals_pass_status === 'Fail' && !doorCheck.is_third_party_report">
                                        <div class="form-group row d-flex align-items-center " v-if="sealFaults.length > 0">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end"
                                                   for="seals-pass-faults">Select faults</label>
                                            <div class="col-lg-6 col-md-12">
                                                <multiselect
                                                        :searchable="false"
                                                        :close-on-select="false"
                                                        v-model="doorCheckDoor.seals_faults"
                                                        :options="sealFaults"
                                                        label="fault_description"
                                                        track-by="door_fault_id"
                                                        :multiple="true"
                                                ></multiselect>
                                            </div>
                                        </div>
                                        <div class="form-group row d-flex align-items-center" v-if="doorCheckDoor.seals_faults && doorCheckDoor.seals_faults.length > 0">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end">Seals Faults Qty</label>
                                            <div class="col-lg-8">
                                                <div class="form-group row d-flex align-items-center " v-for="faultItem in doorCheckDoor.seals_faults" :key="'doorFault'+faultItem.door_fault_id">
                                                    <label class="form-control-label door-fault-label"
                                                    v-bind:for="'qty_'+faultItem.door_fault_id">{{ faultItem.fault_description }}</label>
                                                    <div class="col-md-12">
                                                        <input
                                                                v-model="faultItem.qty"
                                                                v-bind:id="'qty_'+faultItem.door_fault_id"
                                                                class="form-control"
                                                                type="number"
                                                                min="0"
                                                                step="1"
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group row d-flex align-items-center">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end"
                                                   for="seals-pass-additional-comments">Any additional comments</label>
                                            <div class="col-lg-6 col-md-12">
                                        <textarea class="form-control" name="seals_pass_additional_comments"
                                                  v-model="doorCheckDoor.seals_pass_additional_comments"
                                                  id="seals-pass-additional-comments" rows="5"></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center required" v-if="!doorCheck.is_third_party_report">
                                        <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            <label :class="[getContainerClasses('closer_pass_status')]">Closer Passed?</label>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Pass" id="closer-pass-status-pass"
                                                           name="closer_pass_status"
                                                           v-model="doorCheckDoor.closer_pass_status"
                                                           class="door-pass-status question-option--radio-as-button__1 template-option--radio-as-button__pass toggle-hidden-questions-container--close door-pass-status__pass"
                                                    >
                                                    <label for="closer-pass-status-pass">Pass</label>
                                                </li>

                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="closer-pass-status-na"
                                                           name="closer_pass_status"
                                                           v-model="doorCheckDoor.closer_pass_status"
                                                           class="door-pass-status question-option--radio-as-button__2 template-option--radio-as-button__na toggle-hidden-questions-container--close door-pass-status__na"
                                                    >
                                                    <label for="closer-pass-status-na">N/A</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="Fail" id="closer-pass-status-fail"
                                                           name="closer_pass_status"
                                                           v-model="doorCheckDoor.closer_pass_status"
                                                           class="door-pass-status question-option--radio-as-button__3 template-option--radio-as-button__fail toggle-hidden-questions-container--open door-pass-status__fail"
                                                    >
                                                    <label for="closer-pass-status-fail">Fail</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div v-if="doorCheckDoor.closer_pass_status === 'Fail' && !doorCheck.is_third_party_report">
                                        <div class="form-group row d-flex align-items-center " v-if="closerFaults.length > 0">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end"
                                                   for="closer-pass-faults">Select faults</label>
                                            <div class="col-lg-6 col-md-12">
                                                <multiselect
                                                        :searchable="false"
                                                        :close-on-select="false"
                                                        v-model="doorCheckDoor.closer_faults"
                                                        :options="closerFaults"
                                                        label="fault_description"
                                                        track-by="door_fault_id"
                                                        :multiple="true"
                                                ></multiselect>
                                            </div>
                                        </div>
                                        <div class="form-group row d-flex align-items-center" v-if="doorCheckDoor.closer_faults && doorCheckDoor.closer_faults.length > 0">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end">Closer Faults Qty</label>
                                            <div class="col-lg-8">
                                                <div class="form-group row d-flex align-items-center " v-for="faultItem in doorCheckDoor.closer_faults" :key="'doorFault'+faultItem.door_fault_id">
                                                    <label class="form-control-label door-fault-label"
                                                    v-bind:for="'qty_'+faultItem.door_fault_id">{{ faultItem.fault_description }}</label>
                                                    <div class="col-md-12">
                                                        <input
                                                                v-model="faultItem.qty"
                                                                v-bind:id="'qty_'+faultItem.door_fault_id"
                                                                class="form-control"
                                                                type="number"
                                                                min="0"
                                                                step="1"
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group row d-flex align-items-center">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end"
                                                   for="closer-pass-additional-comments">Any additional comments</label>
                                            <div class="col-lg-6 col-md-12">
                                        <textarea class="form-control" name="closer_pass_additional_comments"
                                                  v-model="doorCheckDoor.closer_pass_additional_comments"
                                                  id="closer-pass-additional-comments" rows="5"></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center required" v-if="!doorCheck.is_third_party_report">
                                        <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            <label :class="[getContainerClasses('structure_pass_status')]">
                                                <span v-if="dbName !== 'jpfire' && dbName !== 'qfpc'">Leaf Passed?</span><span v-else>Structure Passed?</span>
                                            </label>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Pass" id="structure-pass-status-pass"
                                                           name="structure_pass_status"
                                                           v-model="doorCheckDoor.structure_pass_status"
                                                           class="door-pass-status question-option--radio-as-button__1 template-option--radio-as-button__pass toggle-hidden-questions-container--close door-pass-status__pass"
                                                    >
                                                    <label for="structure-pass-status-pass">Pass</label>
                                                </li>

                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="structure-pass-status-na"
                                                           name="structure_pass_status"
                                                           v-model="doorCheckDoor.structure_pass_status"
                                                           class="door-pass-status question-option--radio-as-button__2 template-option--radio-as-button__na toggle-hidden-questions-container--close door-pass-status__na"
                                                    >
                                                    <label for="structure-pass-status-na">N/A</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="Fail" id="structure-pass-status-fail"
                                                           name="structure_pass_status"
                                                           v-model="doorCheckDoor.structure_pass_status"
                                                           class="door-pass-status question-option--radio-as-button__3 template-option--radio-as-button__fail toggle-hidden-questions-container--open door-pass-status__fail"
                                                    >
                                                    <label for="structure-pass-status-fail">Fail</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div v-if="doorCheckDoor.structure_pass_status === 'Fail' && !doorCheck.is_third_party_report">
                                        <div class="form-group row d-flex align-items-center " v-if="structureFaults.length > 0">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end"
                                                   for="structure-pass-faults">Select faults</label>
                                            <div class="col-lg-6 col-md-12">
                                                <multiselect
                                                        :searchable="false"
                                                        :close-on-select="false"
                                                        v-model="doorCheckDoor.structure_faults"
                                                        :options="structureFaults"
                                                        label="fault_description"
                                                        track-by="door_fault_id"
                                                        :multiple="true"
                                                ></multiselect>
                                            </div>
                                        </div>
                                        <div class="form-group row d-flex align-items-center" v-if="doorCheckDoor.structure_faults && doorCheckDoor.structure_faults.length > 0">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                                <span v-if="dbName !== 'jpfire' && dbName !== 'qfpc'">Leaf Faults Qty</span><span v-else>Structure Faults Qty</span>
                                            </label>
                                            <div class="col-lg-8">
                                                <div class="form-group row d-flex align-items-center " v-for="faultItem in doorCheckDoor.structure_faults" :key="'doorFault'+faultItem.door_fault_id">
                                                    <label class="form-control-label door-fault-label"
                                                    v-bind:for="'qty_'+faultItem.door_fault_id">{{ faultItem.fault_description }}</label>
                                                    <div class="col-md-12">
                                                        <input
                                                                v-model="faultItem.qty"
                                                                v-bind:id="'qty_'+faultItem.door_fault_id"
                                                                class="form-control"
                                                                type="number"
                                                                min="0"
                                                                step="1"
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group row d-flex align-items-center">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end"
                                                   for="structure-pass-additional-comments">Any additional comments</label>
                                            <div class="col-lg-6 col-md-12">
                                        <textarea class="form-control" name="structure_pass_additional_comments"
                                                  v-model="doorCheckDoor.structure_pass_additional_comments"
                                                  id="structure-pass-additional-comments" rows="5"></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center required" v-if="!doorCheck.is_third_party_report">
                                        <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            <label :class="[getContainerClasses('signage_pass_status')]">Signage Passed?</label>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Pass" id="signage-pass-status-pass"
                                                           name="signage_pass_status"
                                                           v-model="doorCheckDoor.signage_pass_status"
                                                           class="door-pass-status question-option--radio-as-button__1 template-option--radio-as-button__pass toggle-hidden-questions-container--close door-pass-status__pass"
                                                    >
                                                    <label for="signage-pass-status-pass">Pass</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="signage-pass-status-na"
                                                           name="signage_pass_status"
                                                           v-model="doorCheckDoor.signage_pass_status"
                                                           class="door-pass-status question-option--radio-as-button__2 template-option--radio-as-button__na toggle-hidden-questions-container--close door-pass-status__na"
                                                    >
                                                    <label for="signage-pass-status-na">N/A</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="Fail" id="signage-pass-status-fail"
                                                           name="signage_pass_status"
                                                           v-model="doorCheckDoor.signage_pass_status"
                                                           class="door-pass-status question-option--radio-as-button__3 template-option--radio-as-button__fail toggle-hidden-questions-container--open door-pass-status__fail"
                                                    >
                                                    <label for="signage-pass-status-fail">Fail</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div v-if="doorCheckDoor.signage_pass_status === 'Fail' && !doorCheck.is_third_party_report">
                                        <div class="form-group row d-flex align-items-center " v-if="signageFaults.length > 0">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end"
                                                   for="signage-pass-faults">Select faults</label>
                                            <div class="col-lg-6 col-md-12">
                                                <multiselect
                                                        :searchable="false"
                                                        :close-on-select="false"
                                                        v-model="doorCheckDoor.signage_faults"
                                                        :options="signageFaults"
                                                        label="fault_description"
                                                        track-by="door_fault_id"
                                                        :multiple="true"
                                                ></multiselect>
                                            </div>
                                        </div>
                                        <div class="form-group row d-flex align-items-center" v-if="doorCheckDoor.signage_faults && doorCheckDoor.signage_faults.length > 0">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end">Signage Faults Qty</label>
                                            <div class="col-lg-8">
                                                <div class="form-group row d-flex align-items-center " v-for="faultItem in doorCheckDoor.signage_faults" :key="'doorFault'+faultItem.door_fault_id">
                                                    <label class="form-control-label door-fault-label"
                                                    v-bind:for="'qty_'+faultItem.door_fault_id">{{ faultItem.fault_description }}</label>
                                                    <div class="col-md-12">
                                                        <input
                                                                v-model="faultItem.qty"
                                                                v-bind:id="'qty_'+faultItem.door_fault_id"
                                                                class="form-control"
                                                                type="number"
                                                                min="0"
                                                                step="1"
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group row d-flex align-items-center">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end"
                                                   for="signage-pass-additional-comments">Any additional comments</label>
                                            <div class="col-lg-6 col-md-12">
                                        <textarea class="form-control" name="signage_pass_additional_comments"
                                                  v-model="doorCheckDoor.signage_pass_additional_comments"
                                                  id="signage-pass-additional-comments" rows="5"></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center required" v-if="!doorCheck.is_third_party_report">
                                        <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            <label :class="[getContainerClasses('gaps_pass_status')]">Gaps Passed?</label>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Pass" id="gaps-pass-status-pass"
                                                           name="gaps_pass_status"
                                                           v-model="doorCheckDoor.gaps_pass_status"
                                                           class="door-pass-status question-option--radio-as-button__1 template-option--radio-as-button__pass toggle-hidden-questions-container--close door-pass-status__pass"
                                                    >
                                                    <label for="gaps-pass-status-pass">Pass</label>
                                                </li>

                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="gaps-pass-status-na"
                                                           name="gaps_pass_status"
                                                           v-model="doorCheckDoor.gaps_pass_status"
                                                           class="door-pass-status question-option--radio-as-button__2 template-option--radio-as-button__na toggle-hidden-questions-container--close door-pass-status__na"
                                                    >
                                                    <label for="gaps-pass-status-na">N/A</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="Fail" id="gaps-pass-status-fail"
                                                           name="gaps_pass_status"
                                                           v-model="doorCheckDoor.gaps_pass_status"
                                                           class="door-pass-status question-option--radio-as-button__3 template-option--radio-as-button__fail toggle-hidden-questions-container--open door-pass-status__fail"
                                                    >
                                                    <label for="gaps-pass-status-fail">Fail</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div v-if="doorCheckDoor.gaps_pass_status === 'Fail' && !doorCheck.is_third_party_report">
                                        <div class="form-group row d-flex align-items-center" v-if="gapFaults.length > 0">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end"
                                                   for="gaps-pass-faults">Select faults</label>
                                            <div class="col-lg-6 col-md-12">
                                                <multiselect
                                                        :searchable="false"
                                                        :close-on-select="false"
                                                        v-model="doorCheckDoor.gaps_faults"
                                                        :options="gapFaults"
                                                        label="fault_description"
                                                        track-by="door_fault_id"
                                                        :multiple="true"
                                                ></multiselect>
                                            </div>
                                        </div>
                                        <div class="form-group row d-flex align-items-center" v-if="doorCheckDoor.gaps_faults && doorCheckDoor.gaps_faults.length > 0">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end">Gaps Faults Qty</label>
                                            <div class="col-lg-8">
                                                <div class="form-group row d-flex align-items-center " v-for="faultItem in doorCheckDoor.gaps_faults" :key="'doorFault'+faultItem.door_fault_id">
                                                    <label class="form-control-label door-fault-label"
                                                    v-bind:for="'qty_'+faultItem.door_fault_id">{{ faultItem.fault_description }}</label>
                                                    <div class="col-md-12">
                                                        <input
                                                                v-model="faultItem.qty"
                                                                v-bind:id="'qty_'+faultItem.door_fault_id"
                                                                class="form-control"
                                                                type="number"
                                                                min="0"
                                                                step="1"
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group row d-flex align-items-center">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end"
                                                   for="gaps-pass-additional-comments">Any additional comments</label>
                                            <div class="col-lg-6 col-md-12">
                                        <textarea class="form-control" name="gaps_pass_additional_comments"
                                                  v-model="doorCheckDoor.gaps_pass_additional_comments"
                                                  id="gaps-pass-additional-comments" rows="5"></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center required border-top border-bottom pt-3 pb-3 bg-grey" v-if="!doorCheck.is_third_party_report">
                                        <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            <strong>Auto Evaluation</strong>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <span class="c-negative" v-if="doorCheckDoor.frame_pass_status === 'Fail'
                                            || doorCheckDoor.hinge_pass_status === 'Fail'
                                            || doorCheckDoor.lock_pass_status === 'Fail'
                                            || doorCheckDoor.glass_pass_status === 'Fail'
                                            || doorCheckDoor.seals_pass_status === 'Fail'
                                            || doorCheckDoor.closer_pass_status === 'Fail'
                                            || doorCheckDoor.structure_pass_status === 'Fail'
                                            || doorCheckDoor.signage_pass_status === 'Fail'
                                            || doorCheckDoor.gaps_pass_status === 'Fail'
                                            ">Fail</span>
                                            <span class="c-neutral" v-else-if="doorCheckDoor.frame_pass_status === 'N/A'
                                            && doorCheckDoor.hinge_pass_status === 'N/A'
                                            && doorCheckDoor.lock_pass_status === 'N/A'
                                            && doorCheckDoor.glass_pass_status === 'N/A'
                                            && doorCheckDoor.seals_pass_status === 'N/A'
                                            && doorCheckDoor.closer_pass_status === 'N/A'
                                            && doorCheckDoor.structure_pass_status === 'N/A'
                                            && doorCheckDoor.signage_pass_status === 'N/A'
                                            && doorCheckDoor.gaps_pass_status === 'N/A'
                                            ">N/A</span>
                                            <span class="c-positive" v-else-if="(doorCheckDoor.frame_pass_status === 'N/A' || doorCheckDoor.frame_pass_status === 'Pass')
                                            && (doorCheckDoor.hinge_pass_status === 'Pass' || doorCheckDoor.hinge_pass_status === 'N/A')
                                            && (doorCheckDoor.lock_pass_status === 'Pass' || doorCheckDoor.lock_pass_status === 'N/A')
                                            && (doorCheckDoor.glass_pass_status === 'Pass' || doorCheckDoor.glass_pass_status === 'N/A')
                                            && (doorCheckDoor.seals_pass_status === 'Pass' || doorCheckDoor.seals_pass_status === 'N/A')
                                            && (doorCheckDoor.closer_pass_status === 'Pass' || doorCheckDoor.closer_pass_status === 'N/A')
                                            && (doorCheckDoor.structure_pass_status === 'Pass' || doorCheckDoor.structure_pass_status === 'N/A')
                                            && (doorCheckDoor.signage_pass_status === 'Pass' || doorCheckDoor.signage_pass_status === 'N/A')
                                            && (doorCheckDoor.gaps_pass_status === 'Pass' || doorCheckDoor.gaps_pass_status === 'N/A')
                                            ">Pass</span>
                                            <span class="auto-eval" v-else>Can not evaluate yet</span>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center" v-if="!doorCheck.is_third_party_report">
                                        <label
                                            class="col-lg-4 form-control-label d-flex justify-content-lg-end"
                                            for="additional-inspector-notes">Gaps Measurements</label>
                                        <div class="col-lg-8 col-md-12">
                                            <table class="table table-responsive table-condensed table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Gap Position</th>
                                                        <th>Head</th>
                                                        <th>Closing Edge (Single Leaf)</th>
                                                        <th>Meeting Edge (Double Leaf)</th>
                                                        <th>Hinge Edge #1</th>
                                                        <th>Hinge Edge #2</th>
                                                        <th>Sill</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <th>mm</th>
                                                        <td>
                                                            <input
                                                                    name="gap_head"
                                                                    id="gap_head"
                                                                    :class="['form-control', getFieldClasses('gap_head')]"
                                                                    v-model="doorCheckDoor.gap_head"
                                                                    type="text"
                                                                    maxlength="45"
                                                                    @blur="onFieldBlur('gap_head')"
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                    name="gap_closing_edge"
                                                                    id="gap_closing_edge"
                                                                    :class="['form-control', getFieldClasses('gap_closing_edge')]"
                                                                    v-model="doorCheckDoor.gap_closing_edge"
                                                                    type="text"
                                                                    maxlength="45"
                                                                    @blur="onFieldBlur('gap_closing_edge')"
                                                                    v-bind:readonly="doubleDoorSelected"
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                    name="gap_meeting_edge"
                                                                    id="gap_meeting_edge"
                                                                    :class="['form-control', getFieldClasses('gap_meeting_edge')]"
                                                                    v-model="doorCheckDoor.gap_meeting_edge"
                                                                    type="text"
                                                                    maxlength="45"
                                                                    @blur="onFieldBlur('gap_meeting_edge')"
                                                                    v-bind:readonly="singleDoorSelected"
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                    name="gap_hinge_edge_1"
                                                                    id="gap_hinge_edge_1"
                                                                    :class="['form-control', getFieldClasses('gap_hinge_edge_1')]"
                                                                    v-model="doorCheckDoor.gap_hinge_edge_1"
                                                                    type="text"
                                                                    maxlength="45"
                                                                    @blur="onFieldBlur('gap_hinge_edge_1')"
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                    name="gap_hinge_edge_2"
                                                                    id="gap_hinge_edge_2"
                                                                    :class="['form-control', getFieldClasses('gap_hinge_edge_2')]"
                                                                    v-model="doorCheckDoor.gap_hinge_edge_2"
                                                                    type="text"
                                                                    maxlength="45"
                                                                    @blur="onFieldBlur('gap_hinge_edge_2')"
                                                                    v-bind:readonly="singleDoorSelected"
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                    name="gap_still"
                                                                    id="gap_still"
                                                                    :class="['form-control', getFieldClasses('gap_still')]"
                                                                    v-model="doorCheckDoor.gap_still"
                                                                    type="text"
                                                                    maxlength="45"
                                                                    @blur="onFieldBlur('gap_still')"
                                                            />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <div v-if="isErrorField('gap_head')" class="invalid-feedback">The Head field is required</div>
                                            <div v-if="isErrorField('gap_closing_edge')" class="invalid-feedback">The Closing Edge field is required</div>
                                            <div v-if="isErrorField('gap_meeting_edge')" class="invalid-feedback">The Meeting Edge field is required</div>
                                            <div v-if="isErrorField('gap_hinge_edge_1')" class="invalid-feedback">The Hinge Edge #1 field is required</div>
                                            <div v-if="isErrorField('gap_hinge_edge_2')" class="invalid-feedback">The Hinge Edge #2 field is required</div>
                                            <div v-if="isErrorField('gap_still')" class="invalid-feedback">The Sill field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center" v-if="!doorCheck.is_third_party_report">
                                        <label
                                            class="col-lg-4 form-control-label d-flex justify-content-lg-end"
                                            for="additional-inspector-notes">Additional Inspector Notes</label>
                                        <div class="col-lg-6 col-md-12">
                                            <textarea class="form-control"
                                            v-model="doorCheckDoor.additional_inspector_notes"
                                            name="additional_inspector_notes"
                                            maxlength="2000"
                                            id="additional-inspector-notes"
                                            rows="5"></textarea>
                                        </div>
                                    </div>
                                    <div class="form-group row d-flex align-items-center required" v-if="!doorCheck.is_third_party_report">
                                        <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            <label>Include additional inspector notes on report?</label>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="radio-as-buttons">
                                                <li style="width: 45%">
                                                    <input type="radio"
                                                           :value="true"
                                                           id="inor-yes"
                                                           name="include_inspector_notes_on_report"
                                                           class="button-positive"
                                                           v-model="doorCheckDoor.include_inspector_notes_on_report"
                                                    >
                                                    <label for="inor-yes">Yes</label>
                                                </li>
                                                <li style="width: 45%">
                                                    <input type="radio"
                                                           :value="false"
                                                           id="inor-no"
                                                           name="include_inspector_notes_on_report"
                                                           class="button-negative"
                                                           v-model="doorCheckDoor.include_inspector_notes_on_report"
                                                    >
                                                    <label for="inor-no">No</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="form-group border-top" v-if="dbName !== 'jpfire' && dbName !== 'qfpc' && (doorCheckDoor.door_status === doorStatuses[1] || doorCheckDoor.door_status === doorStatuses[2])">
                                        <h2 class="mt-4">Installation</h2>

                                        <div class="form-group row d-flex align-items-center">
                                            <label
                                                    :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end']"
                                                    for="installation_date">
                                                Installation Date
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <datepicker
                                                        v-model="doorCheckDoor.installation_date"
                                                        format="dd/MM/yy"
                                                        input-class="form-control"
                                                        name="installation_date"
                                                ></datepicker>
                                            </div>
                                        </div>

                                        <div class="form-group row d-flex align-items-center ">
                                            <label
                                                    :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('installed_by')]"
                                                    for="installed_by">
                                                Installed By
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <input
                                                        name="installed_by"
                                                        id="installed_by"
                                                        :class="['form-control', getFieldClasses('installed_by')]"
                                                        v-model="doorCheckDoor.installed_by"
                                                        type="text"
                                                        maxlength="255"
                                                        class="form-control"
                                                        @blur="onFieldBlur('installed_by')"
                                                />
                                                <div v-if="isErrorField('installed_by')" class="invalid-feedback">This field is required</div>
                                            </div>
                                        </div>

                                        <div class="form-group row d-flex align-items-center">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                                Actioned Issues
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <multiselect
                                                        :searchable="false"
                                                        :close-on-select="false"
                                                        v-model="doorCheckDoor.actioned_faults"
                                                        :options="allSelectedFaults"
                                                        label="fault_description"
                                                        :custom-label="formattedFaultLabel"
                                                        track-by="door_check_door_fault_id"
                                                        :multiple="true"
                                                ></multiselect>
                                            </div>
                                        </div>


                                        <div class="form-group row d-flex align-items-center">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end" for="installation_comments">
                                                Comments
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <textarea class="form-control"
                                                    v-model="doorCheckDoor.installation_comments"
                                                    name="installation_comments"
                                                    maxlength="2000"
                                                    id="installation_comments"
                                                    rows="5"></textarea>
                                            </div>
                                        </div>


                                        <div class="form-group row align-items-center d-flex">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                                Installer's Signature
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <div class="signature-area" v-if="doorCheckDoor.offline_engineer_signature_image != null">
                                                    <img v-bind:src="doorCheckDoor.offline_engineer_signature_image.data" class="img-fluid">
                                                </div>
                                                <div v-else-if="doorCheckDoor.engineer_signature_image != null">
                                                    Signature uploaded
                                                </div>
                                                <div class="pt-2">
                                                    <div v-if="addingEngineerSignature">
                                                        <div class="signature-area">
                                                            <VueSignaturePad width="100%" height="200px" ref="engineerSignaturePad" />
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-6">
                                                                <a class="btn btn-square btn-lg btn-outline-primary w-100"
                                                                    href="javascript:void(0)"
                                                                    v-on:click="saveEngineerSignature">Save signature</a>
                                                            </div>
                                                            <div class="col-6">
                                                                <a class="btn btn-square btn-lg btn-outline-danger w-100"
                                                                    href="javascript:void(0)"
                                                                    v-on:click="clearEngineerSignature">Clear signature</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <a v-else class="btn btn-square btn-lg btn-outline-primary"
                                                        href="javascript:void(0)"
                                                        v-on:click="addEditEngineerSignature"
                                                    ><span v-if="doorCheckDoor.offline_engineer_signature_image != null || doorCheckDoor.engineer_signature_image != null">Replace</span><span v-else>Add</span> signature</a>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group row d-flex align-items-center">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end text-right">
                                                Photos After Installation
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <div v-for="offlineImage in postInstallationImages" style="margin-bottom: 10px;">
                                                    <img v-bind:src="offlineImage.data" class="img-fluid">
                                                </div>
                                                <div v-if="isPostImageUploading" style="background: #eaeaea; padding: 10px; margin: 10px 0;">
                                                    <h3><span class="fa fa-spin fa-circle-notch"></span>
                                                        Adding image... Please wait...</h3>
                                                </div>
                                                <label class="fileContainer">
                                                    <span class="fa fa-camera"></span> Click to add an image
                                                    <input type="file" accept="image/*" capture="camera" @change="onFileChange($event, doorStatuses[1])">
                                                </label>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="form-group border-top"  v-if="dbName !== 'jpfire' && dbName !== 'qfpc' && doorCheckDoor.door_status === doorStatuses[2]">
                                        <h2 class="mt-4">Audit</h2>

                                        <div class="form-group row d-flex align-items-center">
                                            <label
                                                    :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end']"
                                                    for="audit_date">
                                                Audit Date
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <datepicker
                                                        v-model="doorCheckDoor.audit_date"
                                                        format="dd/MM/yy"
                                                        input-class="form-control"
                                                        name="audit_date"
                                                ></datepicker>
                                            </div>
                                        </div>

                                        <div class="form-group row d-flex align-items-center ">
                                            <label
                                                    :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('audited_by')]"
                                                    for="audited_by">
                                                Audit By
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <input
                                                        name="audited_by"
                                                        id="audited_by"
                                                        :class="['form-control', getFieldClasses('audited_by')]"
                                                        v-model="doorCheckDoor.audited_by"
                                                        type="text"
                                                        maxlength="255"
                                                        class="form-control"
                                                        @blur="onFieldBlur('audited_by')"
                                                />
                                                <div v-if="isErrorField('audited_by')" class="invalid-feedback">This field is required</div>
                                            </div>
                                        </div>

                                        <div class="form-group row d-flex align-items-center">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end" for="audit_comments">
                                                Comments
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <textarea class="form-control"
                                                    v-model="doorCheckDoor.audit_comments"
                                                    name="audit_comments"
                                                    maxlength="2000"
                                                    id="audit_comments"
                                                    rows="5"></textarea>
                                            </div>
                                        </div>

                                        <div class="form-group row align-items-center d-flex">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                                Sign-off Signature
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <div class="signature-area" v-if="doorCheckDoor.offline_sign_off_signature_image != null">
                                                    <img v-bind:src="doorCheckDoor.offline_sign_off_signature_image.data" class="img-fluid">
                                                </div>
                                                <div v-else-if="doorCheckDoor.sign_off_signature_image != null">
                                                    Signature uploaded
                                                </div>
                                                <div class="pt-2">
                                                    <div v-if="addingSignOffSignature">
                                                        <div class="signature-area">
                                                            <VueSignaturePad width="100%" height="200px" ref="signOffSignaturePad" />
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-6">
                                                                <a class="btn btn-square btn-lg btn-outline-primary w-100"
                                                                    href="javascript:void(0)"
                                                                    v-on:click="saveSignOffSignature">Save signature</a>
                                                            </div>
                                                            <div class="col-6">
                                                                <a class="btn btn-square btn-lg btn-outline-danger w-100"
                                                                    href="javascript:void(0)"
                                                                    v-on:click="clearSignOffSignature">Clear signature</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <a v-else class="btn btn-square btn-lg btn-outline-primary"
                                                        href="javascript:void(0)"
                                                        v-on:click="addEditSignOffSignature"
                                                    ><span v-if="doorCheckDoor.offline_sign_off_signature_image != null || doorCheckDoor.sign_off_signature_image != null">Replace</span><span v-else>Add</span> signature</a>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group row d-flex align-items-center">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end text-right">
                                                Audit Findings
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <div v-for="offlineImage in auditImages" style="margin-bottom: 10px;">
                                                    <img v-bind:src="offlineImage.data" class="img-fluid">
                                                </div>
                                                <div v-if="isAuditImageUploading" style="background: #eaeaea; padding: 10px; margin: 10px 0;">
                                                    <h3><span class="fa fa-spin fa-circle-notch"></span>
                                                        Adding image... Please wait...</h3>
                                                </div>
                                                <label class="fileContainer">
                                                    <span class="fa fa-camera"></span> Click to add an image
                                                    <input type="file" accept="image/*" capture="camera" @change="onFileChange($event, doorStatuses[2])">
                                                </label>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="form-group row d-flex align-items-center required" v-if="navigatorOnline && !useOfflineImageUpload">
                                        <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            <label>Door Photos</label>
                                        </div>
                                        <div class="col-lg-6 col-md-12">

                                            <vue-dropzone
                                                    ref="dropzone"
                                                    id="door-dropzone"
                                                    :options="dropOptions"
                                                    :data-url="cmsUrl"
                                                    @vdropzone-complete="afterImageUpload"
                                                    v-on:vdropzone-sending="sendImageToServer"
                                                    v-on:vdropzone-complete="saveImageToForm"
                                            ></vue-dropzone>

                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center" v-if="navigatorOnline && !useOfflineImageUpload">
                                        <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <p class="c-pointer" @click="useOfflineImageUpload = true">Click to use offline uploader</p>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center" v-if="useOfflineImageUpload || !navigatorOnline">
                                        <label class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            Door Photos
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <div v-for="offlineImage in surveyImages" style="margin-bottom: 10px;">
                                                <img v-bind:src="offlineImage.data" class="img-fluid">
                                            </div>
                                            <div v-if="isImageUploading" style="background: #eaeaea; padding: 10px; margin: 10px 0;">
                                                <h3><span class="fa fa-spin fa-circle-notch"></span>
                                                    Adding image... Please wait...</h3>
                                            </div>
                                            <label class="fileContainer">
                                                <span class="fa fa-camera"></span> Click to add an image
                                                <input type="file" accept="image/*" capture="camera" @change="onFileChange($event, doorStatuses[0])">
                                            </label>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center">
                                        <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                        </div>
                                        <div class="col-lg-6 col-md-12" v-if="navigatorOnline && useOfflineImageUpload">
                                            <p class="c-pointer" @click="useOfflineImageUpload = false">If you have an internet connection, you can click here to use the online uploader</p>
                                        </div>
                                    </div>

                                    <div class="alert alert-danger" v-if="isError">
                                        <p class="mb-0">
                                            <strong>The following fields have errors or are missing:</strong>
                                        </p>
                                        <ul class="mb-0 pl-3" v-if="errors.length > 0">
                                            <li v-for="error in errors" v-bind:key="error.field">
                                                <span v-if="error.field">{{ 'form.'+error.field }}<span v-if="error.message">: error.message</span></span>
                                                <span v-else-if="error.message">error.message</span>
                                            </li>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-sm-12">

                            <div class="form-group">
                                <button type="submit" class="btn btn-primary btn-square btn-lg w-100" :disabled="submitting">
                                    <span v-if="submitting">Submitting... <i class="fa fa-circle-notch fa-spin"></i></span>
                                    <span v-else>Save</span>
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </form>



    </div>
</template>


<script>

    import SitePlanMarker from '../components/SitePlanMarker.vue';
    import { required, requiredIf } from 'vuelidate/lib/validators'
    import vueDropzone from 'vue2-dropzone'
    import Multiselect from 'vue-multiselect'
    import Datepicker from 'vuejs-datepicker'
    import ImageRotate from '@/components/mixins/ImageRotate.js'
    import PageLeaveConfirm from '@/components/mixins/PageLeaveConfirm.js'

    var Compress = require('compress.js');
    var EXIF = require('exif-js');

    const glazingPanelFieldsRequired = requiredIf(function () { return this.areGlazingPanelsFieldsRequired });
    const gapsFieldsRequired = requiredIf(function () { return this.areGapsFieldsRequired });
    const requiredForOwnReport = requiredIf(function () { return !this.doorCheck.is_third_party_report });

    export default {
        mixins: [ImageRotate,PageLeaveConfirm],
        data() {
            return {
                useOfflineImageUpload: true,
                addingEngineerSignature: false,
                addingSignOffSignature: false,
                isImageUploading: false,
                isPostImageUploading: false,
                isAuditImageUploading: false,
                doorCheckDoorFound: false,
                doorCheckDoorLoading: true,
                retryDoorSetCount: 0,
                retryDoorTypeCount: 0,
                retryLocationCount: 0,
                retryDoorMaterialCount: 0,
                retryFrameMaterialCount: 0,
                retryDoorCheckDoorCount: 0,
                retryGetDoorCheckCount: 0,
                retryDoorFaultsCount: 0,
                isEdit: false,
                isMounted: false,
                dropOptions: {
                    maxFilesize: 10, // MB
                    // chunking: true,
                    // chunkSize: 500, // Bytes
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    dictDefaultMessage: 'Click here or drop files here to upload. This uploads files directly to the server. If you are having network connectivity problems, click the link below to use the offline uploader, and sync later.',
                    timeout: 300000
                },
                isSubmitted: false,
                isError: false,
                errorHeader: 'error.invalidFields',
                errors: [],
                submitting: false,
                doorCheckDoor: {
                    offline_images: [],
                    site_door_check_door_id: Math.floor(new Date().getTime() / 1000),
                    door_check_id: null,
                    site_door_check_site_plan_id: null,
                    door_check_site_plan_id: null,
                    site_plan_image_position_x: null,
                    site_plan_image_position_y: null,
                    site_plan_image_zoom_level: null,
                    pin_number: null,
                    door_id: null,
                    barcode: null,
                    door_type: '',
                    client_defined_rating: '',
                    door_location: '',
                    door_material: '',
                    frame_material: '',
                    dimensions: null,
                    door_set: '',
                    frame_pass_status: null,
                    hinge_pass_status: null,
                    lock_pass_status: null,
                    glass_pass_status: null,
                    seals_pass_status: null,
                    closer_pass_status: null,
                    structure_pass_status: null,
                    signage_pass_status: null,
                    gaps_pass_status: null,
                    additional_inspector_notes: '',
                    include_inspector_notes_on_report: true,
                    door_photos: null,
                    site_door_check_id: null,
                    door_check_door_images: [],
                    glazing_panels: false,
                    glazing_panels_number: null,
                    glazing_panels_sizes: null,
                    glazing_panels_type: null,
                    substrate_type: '',
                    door_inspected_by: null,
                    gap_head: null,
                    gap_closing_edge: null,
                    gap_meeting_edge: null,
                    gap_hinge_edge_1: null,
                    gap_hinge_edge_2: null,
                    declared_resistance_level: null,
                    level: null,
                    plugs_labels_present: false,
                    test_evidence_available: false,
                    door_status: 'Surveyed',
                    installation_date: null,
                    installation_comments: null,
                    installed_by: null,
                    engineer_signature_image: null,
                    audit_date: null,
                    audit_comments: null,
                    audited_by: null,
                    sign_off_signature_image: null,
                    actioned_faults: [],
                    offline_engineer_signature_image: null,
                    offline_sign_off_signature_image: null
                },
                doorCheck: {
                    door_check_id: null,
                    document_id: 'Loading...',
                    document_title: 'Please wait...',
                    site_door_check_id: this.isEdit ? null : this.$route.params.id,
                },
                doorSets: null,
                doorMaterials: null,
                frameMaterials: null,
                locations: null,
                substrateTypes: [],
                doorTypes: null,
                clientDefinedRatings: [],
                doorPartArray: [],
                declaredResistanceLevels: [],
                levelOptions: [],
                sitePlans: [],
                frameFaults: null,
                hingeFaults: null,
                lockFaults: null,
                glassFaults: null,
                sealFaults: null,
                closerFaults: null,
                structureFaults: null,
                signageFaults: null,
                gapFaults: null,
                site_door_check_id: null,
                doorStatuses: ['Surveyed', 'Completion Report', 'Audited']
            }
        },
        validations: {
            doorCheckDoor: {
                door_id: { required },
                door_type: { required },
                door_location: { required },
                door_material: { required: requiredForOwnReport },
                frame_material: { required: requiredForOwnReport },
                door_set: { required: requiredForOwnReport },
                frame_pass_status: { required: requiredForOwnReport },
                hinge_pass_status: { required: requiredForOwnReport },
                lock_pass_status: { required: requiredForOwnReport },
                glass_pass_status: { required: requiredForOwnReport },
                seals_pass_status: { required: requiredForOwnReport },
                closer_pass_status: { required: requiredForOwnReport },
                structure_pass_status: { required: requiredForOwnReport },
                signage_pass_status: { required: requiredForOwnReport },
                gaps_pass_status: { required: requiredForOwnReport },
                glazing_panels_number: { required: glazingPanelFieldsRequired },
                glazing_panels_sizes: { required: glazingPanelFieldsRequired },
                gap_head: { required: gapsFieldsRequired },
                gap_closing_edge: { required: gapsFieldsRequired },
                gap_meeting_edge: { required: gapsFieldsRequired },
                gap_hinge_edge_1: { required: gapsFieldsRequired },
                gap_hinge_edge_2: { required: gapsFieldsRequired },
                gap_still: { required: gapsFieldsRequired },
                site_plan_image_position_x: { required: requiredIf(function () { return this.isSitePlanPositionRequired }) },
                door_status: { required: requiredIf(function () { return this.dbName !== 'jpfire' && this.dbName !== 'qfpc' }) },
                door_inspected_by: { required: requiredIf(function () { return this.dbName !== 'jpfire' && this.dbName !== 'qfpc' }) }
            },
        },
        components: {
            vueDropzone,
            Multiselect,
            Datepicker,
            SitePlanMarker
        },
        methods: {
            formattedFaultLabel(fault) {
                let parts = [];
                if(fault.fault_code) {
                    parts.push(fault.fault_code);
                }
                if(fault.fault_description) {
                    parts.push(fault.fault_description);
                }
                return parts.join(' | ');
            },
            navigatorOnline() {
                if (!navigator.onLine) {
                    this.useOfflineImageUpload = true;
                }
                return navigator.onLine;
            },
            onFileChange(e, doorStatus) {
                if(doorStatus === this.doorStatuses[2]) {
                    this.isAuditImageUploading = true;
                } else if (doorStatus === this.doorStatuses[1]) {
                    this.isPostImageUploading = true;
                } else {
                    this.isImageUploading = true;
                }
                
                var files = e.target.files || e.dataTransfer.files
                if (!files.length) {
                    if(doorStatus === this.doorStatuses[2]) {
                        this.isAuditImageUploading = false;
                    } else if (doorStatus === this.doorStatuses[1]) {
                        this.isPostImageUploading = false;
                    } else {
                        this.isImageUploading = false;
                    }
                    return;
                }
                var vm = this;
                EXIF.getData(files[0], function() {
                    var orientation = EXIF.getTag(this, "Orientation");
                    vm.createImage(files[0], orientation, doorStatus);
                });
            },
            createImage(file, orientation, doorStatus) {
                var compress = new Compress()
                var files = [file]
                var vm = this;
                compress.compress(files, {
                    size: 4, // the max size in MB, defaults to 2MB
                    quality: .6, // the quality of the image, max is 1,
                    maxWidth: 700, // the max width of the output image, defaults to 1920px
                    maxHeight: 700, // the max height of the output image, defaults to 1920px
                    resize: true, // defaults to true, set false if you do not want to resize the image width and height
                }).then(async (data) => {
                    var imgSrc = data[0].prefix + data[0].data;
                    var rotationDegrees = 0;
                    switch(orientation) {
                        case 3:
                            rotationDegrees = 180;
                            break;
                        case 6:
                            rotationDegrees = -90;
                            break;
                        case 8:
                            rotationDegrees = 90;
                            break;    
                    }

                    if(rotationDegrees != 0) {
                        await this.rotateImage(imgSrc, rotationDegrees).then(newDataUri => {
                            console.log('Image rotated');
                            imgSrc = newDataUri;
                        }).catch(e => {
                            console.log(e);
                        });
                    }

                    console.log('Image added to array');
                    this.doorCheckDoor.offline_images.push({
                        'data': imgSrc, 
                        'alt': data[0].alt, 
                        'orientation': orientation, 
                        'offline_image_id': this.$session.get('user_id').toString() + Math.floor(new Date().getTime() / 1000),
                        'door_status': doorStatus
                    });
                    if(doorStatus === this.doorStatuses[2]) {
                        this.isAuditImageUploading = false;
                    } else if (doorStatus === this.doorStatuses[1]) {
                        this.isPostImageUploading = false;
                    } else {
                        this.isImageUploading = false;
                    }
                });
            },
            clearEngineerSignature() {
                this.$refs.engineerSignaturePad.clearSignature();
            },
            saveEngineerSignature() {
                const { isEmpty, data } = this.$refs.engineerSignaturePad.saveSignature();

                if(!isEmpty) {
                    this.doorCheckDoor.offline_engineer_signature_image = {
                        data: data
                    };
                }
                
                this.addingEngineerSignature = false;
                this.clearEngineerSignature();
            },
            addEditEngineerSignature() {
                this.addingEngineerSignature = true;
            },
            clearSignOffSignature() {
                this.$refs.signOffSignaturePad.clearSignature();
            },
            saveSignOffSignature() {
                const { isEmpty, data } = this.$refs.signOffSignaturePad.saveSignature();

                if(!isEmpty) {
                    this.doorCheckDoor.offline_sign_off_signature_image = {
                        data: data
                    };
                }
                
                this.addingSignOffSignature = false;
                this.clearSignOffSignature();
            },
            addEditSignOffSignature() {
                this.addingSignOffSignature = true;
            },
            sendImageToServer(file, xhr, formData) {
                formData.append('user_id', 1);
            },
            saveImageToForm(response) {
                var imageData = JSON.parse(response.xhr.response);
                if (imageData.success) {
                    this.doorCheckDoor.door_check_door_images.push({image: imageData.image_data, image_id: imageData.image_data.image_id});
                }
            },
            getDoorSets() {
                var vmt = this;
                this.getDb(function onConnectedGetDoorSets(db) {
                    var vm = vmt;
                    vm.doorSets = [];
                    try {
                        var objectStore = db.transaction('door_sets').objectStore('door_sets');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vm.doorSets) {
                                        vm.doorSets.push({
                                            door_set_id: cursor.value.door_set_id,
                                            door_set_name: cursor.value.door_set_name,
                                        })
                                        cursor.continue();
                                    }
                                }
                            };
                        }
                    } catch (e) {
                        console.log(e);
                    }

                });
            },

            getDoorTypes() {
                var vmt = this;
                this.getDb(function onConnectedGetDoorSets(db) {

                    var vm = vmt;
                    vm.doorTypes = [];
                    try {
                        var objectStore = db.transaction('door_types').objectStore('door_types');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vm.doorTypes) {
                                        vm.doorTypes.push({
                                            door_type_id: cursor.value.door_type_id,
                                            door_type_name: cursor.value.door_type_name,
                                        })
                                    }
                                    cursor.continue();
                                }
                            };
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },

            getClientDefinedRatings() {
                var vm = this;
                this.getDb(function onConnectedGetDoorSets(db) {
                    vm.clientDefinedRatings = [];
                    try {
                        var objectStore = db.transaction('client_defined_ratings').objectStore('client_defined_ratings');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vm.clientDefinedRatings) {
                                        vm.clientDefinedRatings.push({
                                            client_defined_rating_id: cursor.value.client_defined_rating_id,
                                            client_defined_rating_name: cursor.value.client_defined_rating_name,
                                        })
                                    }
                                    cursor.continue();
                                }
                            };
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },

            getLocations() {
                var vmt = this;
                this.getDb(function onConnectedGetDoorSets(db) {

                    var vm = vmt;
                    vm.locations = [];
                    try {
                        var objectStore = db.transaction('locations').objectStore('locations');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vm.locations) {
                                        vm.locations.push({
                                            location_id: cursor.value.location_id,
                                            location_name: cursor.value.location_name,
                                        })
                                    }
                                    cursor.continue();
                                }
                            };
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },

            getSubstrateTypes() {
                var vm = this;
                this.getDb(function onConnectedGetSubstrateTypes(db) {
                    vm.substrateTypes = [];
                    try {
                        var objectStore = db.transaction('substrate_types').objectStore('substrate_types');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vm.substrateTypes) {
                                        vm.substrateTypes.push({
                                            substrate_type_id: cursor.value.substrate_type_id,
                                            substrate_type_name: cursor.value.substrate_type_name,
                                        })
                                    }
                                    cursor.continue();
                                }
                            };
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },

            getDoorMaterials() {
                var vmt = this;
                this.getDb(function onConnectedGetDoorSets(db) {

                    var vm = vmt;
                    vm.doorMaterials = [];
                    try {
                        var objectStore = db.transaction('door_materials').objectStore('door_materials');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vm.doorMaterials) {
                                        vm.doorMaterials.push({
                                            door_material_id: cursor.value.door_material_id,
                                            material_name: cursor.value.material_name,
                                        })
                                    }
                                    cursor.continue();
                                }
                            };
                        }
                    } catch (e) {
                        console.log(e);
                    }
                })
            },

            getFrameMaterials() {
                var vmt = this;
                this.getDb(function onConnectedGetDoorSets(db) {

                    var vm = vmt;
                    vm.frameMaterials = [];
                    try {
                        var objectStore = db.transaction('frame_materials').objectStore('frame_materials');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vm.frameMaterials) {
                                        vm.frameMaterials.push({
                                            frame_material_id: cursor.value.frame_material_id,
                                            material_name: cursor.value.material_name,
                                        })
                                    }
                                    cursor.continue();
                                }
                            };
                        }
                    } catch (e) {
                        console.log(e);
                    }
                })
            },
            getDeclaredResistanceLevels() {
                var vmt = this;
                this.getDb(function onConnectedGetDoorSets(db) {

                    var vm = vmt;
                    vm.declaredResistanceLevels = [];
                    try {
                        var objectStore = db.transaction('declared_resistance_levels').objectStore('declared_resistance_levels');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vm.declaredResistanceLevels) {
                                        vm.declaredResistanceLevels.push({
                                            declared_resistance_level_id: cursor.value.declared_resistance_level_id,
                                            declared_resistance_level_title: cursor.value.declared_resistance_level_title,
                                        })
                                    }
                                    cursor.continue();
                                }
                            };
                        }
                    } catch (e) {
                        console.log(e);
                    }
                })
            },
            getLevelOptions() {
                var vmt = this;
                this.getDb(function onConnectedGetDoorSets(db) {

                    var vm = vmt;
                    vm.levelOptions = [];
                    try {
                        var objectStore = db.transaction('level_options').objectStore('level_options');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vm.levelOptions) {
                                        vm.levelOptions.push({
                                            level_option_id: cursor.value.level_option_id,
                                            level_option_title: cursor.value.level_option_title,
                                        })
                                    }
                                    cursor.continue();
                                }
                            };
                        }
                    } catch (e) {
                        console.log(e);
                    }
                })
            },
            getDefaultInspectorNotes() {
                var vmt = this;
                this.getDb(function onConnectedGetDoorSets(db) {

                    var vm = vmt;
                    try {
                        var objectStore = db.transaction('door_check_report_configurations').objectStore('door_check_report_configurations');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vm.doorCheckDoor) {
                                        vm.doorCheckDoor.additional_inspector_notes = cursor.value.default_inspector_notes_per_door;
                                    }
                                    cursor.continue();

                                }
                            };
                        }
                    } catch (e) {
                        console.log(e);
                    }
                })
            },
            generateMarkerNumber() {
                var vm = this;
                this.getDb(function onConnectedDb(db) {
                    try {
                        var objectStore = db.transaction('door_check_doors').objectStore('door_check_doors');
                        if (objectStore) {
                            var highestMarkerNumber = null;
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if(
                                        cursor.value.site_door_check_id == vm.doorCheck.site_door_check_id && 
                                        cursor.value.pin_number &&
                                        (cursor.value.is_deleted === false || cursor.value.is_deleted === undefined) &&
                                        (!highestMarkerNumber || highestMarkerNumber < cursor.value.pin_number)
                                    ) {
                                        highestMarkerNumber = cursor.value.pin_number;
                                    }
                                    cursor.continue();
                                } else if(!highestMarkerNumber) {
                                    vm.doorCheckDoor.pin_number = 1;
                                } else {
                                    vm.doorCheckDoor.pin_number = highestMarkerNumber + 1;
                                }
                            }
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
            getDoorCheckDoor() {
                var vmt = this;
                this.getDb(function onConnectedGetDoorSets(db) {

                    var vm = vmt;
                    try {
                        var doorCheckDoorId = parseInt(vm.$route.params.id);
                        var objectStore = db.transaction('door_check_doors').objectStore('door_check_doors');
                        var storeRequest = objectStore.get(doorCheckDoorId);
                        storeRequest.onsuccess = function(event) {
                            if (storeRequest.result !== undefined) {
                                vm.doorCheckDoor = storeRequest.result;
                                if (vm.doorCheckDoor.door_status === undefined) {
                                    vm.doorCheckDoor.door_status = vm.doorStatuses[0];
                                }
                                if (vm.doorCheckDoor.door_inspected_by === undefined) {
                                    vm.doorCheckDoor.door_inspected_by = null;
                                }

                                let generateNumber = false;
                                if(!vm.doorCheckDoor.pin_number) {
                                    generateNumber = true;
                                }

                                vm.getDoorCheck(generateNumber);
                                vm.doorCheckDoorFound = true;
                            }
                            
                            vm.doorCheckDoorLoading = false;
                        };
                        storeRequest.onerror = function(e) {
                            vm.doorCheckDoorFound = false;
                            vm.doorCheckDoorLoading = false;
                        }
                    } catch (e) {
                        console.log(e);
                    }
                })
            },
            getDoorCheck(generateMarkerNo) {
                var vmt = this;
                this.getDb(function onConnectedGetDoorSets(db) {

                    var vm = vmt;
                    try {
                        var doorCheckId = vm.isEdit ? vm.doorCheckDoor.site_door_check_id : parseInt(vm.$route.params.id);
                        var objectStore = db.transaction('door_checks').objectStore('door_checks');
                        var storeRequest = objectStore.get(doorCheckId);
                        storeRequest.onsuccess = function(event) {
                            vm.doorCheck = storeRequest.result;
                            if (storeRequest.result !== undefined) {
                                console.log(vm.doorCheck);
                                vm.doorCheckDoor.site_door_check_id = vm.doorCheck.site_door_check_id;
                                vm.doorCheckFound = true;
                                if(generateMarkerNo) {
                                    vm.generateMarkerNumber();
                                }
                                vm.getSitePlans();
                            }
                            vm.doorCheckLoading = false;
                        };
                        storeRequest.onerror = function(e) {
                            vm.doorCheckFound = false;
                            vm.doorCheckLoading = false;
                        }
                    } catch (e) {
                        console.log(e);
                    }
                })
            },
            getDoorFaults() {
                var vmt = this;
                this.getDb(function onConnectedGetDoorSets(db) {

                    var vm = vmt;
                    vm.frameFaults = [];
                    vm.hingeFaults = [];
                    vm.lockFaults = [];
                    vm.glassFaults = [];
                    vm.sealFaults = [];
                    vm.closerFaults = [];
                    vm.structureFaults = [];
                    vm.signageFaults = [];
                    vm.gapFaults = [];
                    vm.frameFaultsMS = [];
                    vm.hingeFaultsMS = [];
                    vm.lockFaultsMS = [];
                    vm.glassFaultsMS = [];
                    vm.sealFaultsMS = [];
                    vm.closerFaultsMS = [];
                    vm.structureFaultsMS = [];
                    vm.signageFaultsMS = [];
                    vm.gapFaultsMS = [];
                    try {
                        var objectStore = db.transaction('door_faults').objectStore('door_faults');
                        if (objectStore) {
                            let faultId = 1;
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (cursor.value.door_part === 2) {
                                        vm.frameFaults.push({
                                            door_check_door_fault_id: 'FLT' + faultId++,
                                            door_fault_id: cursor.value.door_fault_id,
                                            fault_description: cursor.value.fault_description,
                                            fault_code: cursor.value.fault_code,
                                        });
                                    } else if (cursor.value.door_part === 3) {
                                        vm.hingeFaults.push({
                                            door_check_door_fault_id: 'FLT' + faultId++,
                                            door_fault_id: cursor.value.door_fault_id,
                                            fault_description: cursor.value.fault_description,
                                            fault_code: cursor.value.fault_code,
                                        });
                                    } else if (cursor.value.door_part === 4) {
                                        vm.lockFaults.push({
                                            door_check_door_fault_id: 'FLT' + faultId++,
                                            door_fault_id: cursor.value.door_fault_id,
                                            fault_description: cursor.value.fault_description,
                                            fault_code: cursor.value.fault_code,
                                        });
                                    } else if (cursor.value.door_part === 5) {
                                        vm.glassFaults.push({
                                            door_check_door_fault_id: 'FLT' + faultId++,
                                            door_fault_id: cursor.value.door_fault_id,
                                            fault_description: cursor.value.fault_description,
                                            fault_code: cursor.value.fault_code,
                                        });
                                    } else if (cursor.value.door_part === 6) {
                                        vm.sealFaults.push({
                                            door_check_door_fault_id: 'FLT' + faultId++,
                                            door_fault_id: cursor.value.door_fault_id,
                                            fault_description: cursor.value.fault_description,
                                            fault_code: cursor.value.fault_code,
                                        });
                                    } else if (cursor.value.door_part === 7) {
                                        vm.closerFaults.push({
                                            door_check_door_fault_id: 'FLT' + faultId++,
                                            door_fault_id: cursor.value.door_fault_id,
                                            fault_description: cursor.value.fault_description,
                                            fault_code: cursor.value.fault_code,
                                        });
                                    } else if (cursor.value.door_part === 8) {
                                        vm.structureFaults.push({
                                            door_check_door_fault_id: 'FLT' + faultId++,
                                            door_fault_id: cursor.value.door_fault_id,
                                            fault_description: cursor.value.fault_description,
                                            fault_code: cursor.value.fault_code,
                                        });
                                    } else if (cursor.value.door_part === 9) {
                                        vm.signageFaults.push({
                                            door_check_door_fault_id: 'FLT' + faultId++,
                                            door_fault_id: cursor.value.door_fault_id,
                                            fault_description: cursor.value.fault_description,
                                            fault_code: cursor.value.fault_code,
                                        });
                                    } else if (cursor.value.door_part === 10) {
                                        vm.gapFaults.push({
                                            door_check_door_fault_id: 'FLT' + faultId++,
                                            door_fault_id: cursor.value.door_fault_id,
                                            fault_description: cursor.value.fault_description,
                                            fault_code: cursor.value.fault_code,
                                        });
                                    }

                                    cursor.continue();
                                } else {
                                    vm.frameFaults.sort(vm.sortFaults);
                                    vm.hingeFaults.sort(vm.sortFaults);
                                    vm.lockFaults.sort(vm.sortFaults);
                                    vm.glassFaults.sort(vm.sortFaults);
                                    vm.sealFaults.sort(vm.sortFaults);
                                    vm.closerFaults.sort(vm.sortFaults);
                                    vm.structureFaults.sort(vm.sortFaults);
                                    vm.signageFaults.sort(vm.sortFaults);
                                    vm.gapFaults.sort(vm.sortFaults);
                                }

                            };
                        }
                    } catch (e) {
                        console.log(e);
                    }

                })
            },
            sortFaults(a, b) {
                if(!a.fault_code) {
                    return 1;
                } else if (!b.fault_code) {
                    return -1;
                }

                return (a.fault_code > b.fault_code) ? 1 : ((b.fault_code > a.fault_code) ? -1 : 0);
            },
            afterImageUpload(file) {
                console.log(file);
            },
            getSitePlans() {
                var vm = this;
                vm.sitePlans = [];
                this.getDb(function onConnectedDb(db) {
                    try {
                        var objectStore = db.transaction('door_check_site_plans').objectStore('door_check_site_plans');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if(
                                        cursor.value.site_door_check_id == vm.doorCheck.site_door_check_id && 
                                        (cursor.value.is_deleted === false || cursor.value.is_deleted === undefined)
                                    ) {
                                        vm.sitePlans.push(cursor.value);
                                    }
                                    cursor.continue();
                                }
                            }
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
            submit() {
                this.$v.$touch();
                if (!this.$v.$error) {
                    this.ignoreLeaveEvent = true;
                    this.sendFormData();
                } else {
                    this.validationError();
                }
            },
            enableSubmitLoader() {
                this.submitting = true;
            },
            disableSubmitLoader() {
                this.submitting = false;
            },
            sendFormData() {
                this.enableSubmitLoader();

                if(!this.doorCheckDoor.site_door_check_site_plan_id) {
                    this.doorCheckDoor.door_check_site_plan_id = null;
                    this.doorCheckDoor.site_plan_image_position_x = null;
                    this.doorCheckDoor.site_plan_image_position_y = null;
                    this.doorCheckDoor.site_plan_image_zoom_level = null;
                    this.doorCheckDoor.pin_number = null;
                } else {
                    this.doorCheckDoor.site_plan_image_zoom_level = this.$refs.sitePlanComp.getZoomLevel();
                }

                var vmt = this;
                this.getDb(function onConnectedGetDoorSets(db) {

                    var vm = vmt;
                    var putRequest = db.transaction('door_check_doors', 'readwrite')
                        .objectStore('door_check_doors').put({
                            additional_inspector_notes: vm.doorCheckDoor.additional_inspector_notes,
                            any_faults: [],
                            barcode: vm.doorCheckDoor.barcode,
                            closer_faults: vm.doorCheckDoor.closer_faults,
                            closer_pass_additional_comments: vm.doorCheckDoor.closer_pass_additional_comments,
                            closer_pass_status: vm.doorCheckDoor.closer_pass_status,
                            dimensions: vm.doorCheckDoor.dimensions,
                            door_check: {site_door_check_id: vm.doorCheck.site_door_check_id},
                            door_check_door_images: vm.doorCheckDoor.door_check_door_images,
                            door_check_door_id: vm.doorCheckDoor.door_check_door_id,
                            door_check_id: vm.doorCheck.door_check_id,
                            site_door_check_site_plan_id: vm.doorCheckDoor.site_door_check_site_plan_id !== undefined ? vm.doorCheckDoor.site_door_check_site_plan_id : null,
                            door_check_site_plan_id: vm.doorCheckDoor.door_check_site_plan_id !== undefined ? vm.doorCheckDoor.door_check_site_plan_id : null,
                            site_plan_image_position_x: vm.doorCheckDoor.site_plan_image_position_x !== undefined ? vm.doorCheckDoor.site_plan_image_position_x : null,
                            site_plan_image_position_y: vm.doorCheckDoor.site_plan_image_position_y !== undefined ? vm.doorCheckDoor.site_plan_image_position_y : null,
                            site_plan_image_zoom_level: vm.doorCheckDoor.site_plan_image_zoom_level !== undefined ? vm.doorCheckDoor.site_plan_image_zoom_level : null,
                            pin_number: vm.doorCheckDoor.pin_number !== undefined ? vm.doorCheckDoor.pin_number : null,
                            door_id: vm.doorCheckDoor.door_id,
                            door_location: vm.doorCheckDoor.door_location,
                            glazing_panels: vm.doorCheckDoor.glazing_panels !== undefined ? vm.doorCheckDoor.glazing_panels : false,
                            glazing_panels_number: vm.doorCheckDoor.glazing_panels_number !== undefined ? vm.doorCheckDoor.glazing_panels_number : null,
                            glazing_panels_sizes: vm.doorCheckDoor.glazing_panels_sizes !== undefined ? vm.doorCheckDoor.glazing_panels_sizes : null,
                            glazing_panels_type: vm.doorCheckDoor.glazing_panels_type !== undefined ? vm.doorCheckDoor.glazing_panels_type : null,
                            substrate_type: vm.doorCheckDoor.substrate_type !== undefined ? vm.doorCheckDoor.substrate_type : '',
                            door_inspected_by: vm.doorCheckDoor.door_inspected_by !== undefined ? vm.doorCheckDoor.door_inspected_by : null,
                            gap_head: vm.doorCheckDoor.gap_head !== undefined ? vm.doorCheckDoor.gap_head : null,
                            gap_closing_edge: vm.doorCheckDoor.gap_closing_edge !== undefined ? vm.doorCheckDoor.gap_closing_edge : null,
                            gap_meeting_edge: vm.doorCheckDoor.gap_meeting_edge !== undefined ? vm.doorCheckDoor.gap_meeting_edge : null,
                            gap_hinge_edge_1: vm.doorCheckDoor.gap_hinge_edge_1 !== undefined ? vm.doorCheckDoor.gap_hinge_edge_1 : null,
                            gap_hinge_edge_2: vm.doorCheckDoor.gap_hinge_edge_2 !== undefined ? vm.doorCheckDoor.gap_hinge_edge_2 : null,
                            gap_still: vm.doorCheckDoor.gap_still !== undefined ? vm.doorCheckDoor.gap_still : null,
                            door_material: vm.doorCheckDoor.door_material,
                            door_set: vm.doorCheckDoor.door_set,
                            door_type: vm.doorCheckDoor.door_type,
                            client_defined_rating: vm.doorCheckDoor.client_defined_rating !== undefined ? vm.doorCheckDoor.client_defined_rating : '',
                            frame_faults: vm.doorCheckDoor.frame_faults,
                            frame_material: vm.doorCheckDoor.frame_material,
                            frame_pass_additional_comments: vm.doorCheckDoor.frame_pass_additional_comments,
                            frame_pass_status: vm.doorCheckDoor.frame_pass_status,
                            gaps_faults: vm.doorCheckDoor.gaps_faults,
                            gaps_pass_additional_comments: vm.doorCheckDoor.gaps_pass_additional_comments,
                            gaps_pass_status: vm.doorCheckDoor.gaps_pass_status,
                            glass_faults: vm.doorCheckDoor.glass_faults,
                            glass_pass_additional_comments: vm.doorCheckDoor.glass_pass_additional_comments,
                            glass_pass_status: vm.doorCheckDoor.glass_pass_status,
                            hinge_faults: vm.doorCheckDoor.hinge_faults,
                            hinge_pass_additional_comments: vm.doorCheckDoor.hinge_pass_additional_comments,
                            hinge_pass_status: vm.doorCheckDoor.hinge_pass_status,
                            include_inspector_notes_on_report: vm.doorCheckDoor.include_inspector_notes_on_report,
                            lock_faults: vm.doorCheckDoor.lock_faults,
                            lock_pass_additional_comments: vm.doorCheckDoor.lock_pass_additional_comments,
                            lock_pass_status: vm.doorCheckDoor.lock_pass_status,
                            seals_faults: vm.doorCheckDoor.seals_faults,
                            seals_pass_additional_comments: vm.doorCheckDoor.seals_pass_additional_comments,
                            seals_pass_status: vm.doorCheckDoor.seals_pass_status,
                            signage_faults: vm.doorCheckDoor.signage_faults,
                            signage_pass_additional_comments: vm.doorCheckDoor.signage_pass_additional_comments,
                            signage_pass_status: vm.doorCheckDoor.signage_pass_status,
                            site_door_check_door_id: vm.doorCheckDoor.site_door_check_door_id,
                            site_door_check_id: vm.doorCheckDoor.site_door_check_id,
                            structure_faults: vm.doorCheckDoor.structure_faults,
                            structure_pass_additional_comments: vm.doorCheckDoor.structure_pass_additional_comments,
                            structure_pass_status: vm.doorCheckDoor.structure_pass_status,
                            declared_resistance_level: vm.doorCheckDoor.declared_resistance_level !== undefined ? vm.doorCheckDoor.declared_resistance_level : null,
                            level: vm.doorCheckDoor.level !== undefined ? vm.doorCheckDoor.level : null,
                            plugs_labels_present: vm.doorCheckDoor.plugs_labels_present !== undefined ? vm.doorCheckDoor.plugs_labels_present : false,
                            test_evidence_available: vm.doorCheckDoor.test_evidence_available !== undefined ? vm.doorCheckDoor.test_evidence_available : false,
                            door_status: vm.doorCheckDoor.door_status !== undefined ? vm.doorCheckDoor.door_status : null,
                            installation_date: vm.doorCheckDoor.installation_date !== undefined ? vm.doorCheckDoor.installation_date : null,
                            installation_comments: vm.doorCheckDoor.installation_comments !== undefined ? vm.doorCheckDoor.installation_comments : null,
                            installed_by: vm.doorCheckDoor.installed_by !== undefined ? vm.doorCheckDoor.installed_by : null,
                            engineer_signature_image: vm.doorCheckDoor.engineer_signature_image !== undefined ? vm.doorCheckDoor.engineer_signature_image : null,
                            audit_date: vm.doorCheckDoor.audit_date !== undefined ? vm.doorCheckDoor.audit_date : null,
                            audit_comments: vm.doorCheckDoor.audit_comments !== undefined ? vm.doorCheckDoor.audit_comments : null,
                            audited_by: vm.doorCheckDoor.audited_by !== undefined ? vm.doorCheckDoor.audited_by : null,
                            sign_off_signature_image: vm.doorCheckDoor.sign_off_signature_image !== undefined ? vm.doorCheckDoor.sign_off_signature_image : null,
                            offline_images: vm.doorCheckDoor.offline_images,
                            actioned_faults: vm.doorCheckDoor.actioned_faults !== undefined ? vm.doorCheckDoor.actioned_faults : [],
                            user_id: vm.$session.get('user_id'),
                            offline_engineer_signature_image: vm.doorCheckDoor.offline_engineer_signature_image !== undefined ? vm.doorCheckDoor.offline_engineer_signature_image : null,
                            offline_sign_off_signature_image: vm.doorCheckDoor.offline_sign_off_signature_image !== undefined ? vm.doorCheckDoor.offline_sign_off_signature_image : null,
                        });
                    putRequest.onsuccess = function(event) {
                        vm.submitSuccess({
                            success: true,
                            site_door_check_door_id: putRequest.result,
                        })
                    }
                    putRequest.onerror = function(event) {
                        alert("Unable to add data ");
                    };
                })

            },
            submitSuccess(response) {
                if (response.success) {
                    this.isSubmitted = true;
                    this.isError = false;
                    this.$router.push({ name: 'door-check-view-door', params: {id: response.site_door_check_door_id} })
                } else {
                    this.errorHeader = 'error.invalidFields';
                    this.errors = response.data.errors;
                    this.isError = true;
                }
            },
            submitError(error) {
                this.errorHeader = 'error.general';
                this.errors = [{'field': null, 'message': 'error.generalMessage'}];
                this.isError = true;
            },
            validationError() {
                this.errorHeader = 'error.invalidFields';
                this.errors = this.getErrors();
                this.isError = true;
            },
            isErrorField(field) {
                try {
                    if (this.getValidationField(field).$error) {
                        return true;
                    }
                } catch (error) {}

                return this.errors.some(el => el.field === field);
            },
            getErrors() {
                let errors = [];
                for (var field of Object.keys(this.doorCheckDoor)) {
                    try {
                        if (this.getValidationField(field).$error) {
                            errors.push({'field': field, 'message': null});
                        }
                    } catch (error) {}
                }
                return errors;
            },
            getFieldClasses(field) {
                return { 'is-invalid': this.isErrorField(field) }
            },
            getContainerClasses(field) {
                return { 'text-danger': this.isErrorField(field) }
            },
            getValidationField(field) {
                if (this.$v.doorCheckDoor[field]) {
                    return this.$v.doorCheckDoor[field];
                }
                throw Error('No validation for field ' + field);
            },
            onDoorSetChanged() {
                if(this.doubleDoorSelected) {
                    this.doorCheckDoor.gap_closing_edge = 'N/A';
                } else if (this.singleDoorSelected) {
                    this.doorCheckDoor.gap_meeting_edge = 'N/A';
                    this.doorCheckDoor.gap_hinge_edge_2 = 'N/A';
                }
            },
            onFieldBlur(field) {
                try {
                    this.getValidationField(field).$touch();
                    if (this.getValidationField(field).$error) {
                        if (!this.errors.some(el => el.field === field)) {
                            this.errors.push({'field': field, 'message': null});
                        }
                    } else {
                        this.errors = this.errors.filter(el => el.field !== field);
                    }
                } catch (error) {}
            },
            reload() {
                window.location = '';
            },
            markAllAsPass() {
                this.doorCheckDoor.frame_pass_status = 'Pass';
                this.doorCheckDoor.hinge_pass_status = 'Pass';
                this.doorCheckDoor.lock_pass_status = 'Pass';
                this.doorCheckDoor.glass_pass_status = 'Pass';
                this.doorCheckDoor.seals_pass_status = 'Pass';
                this.doorCheckDoor.closer_pass_status = 'Pass';
                this.doorCheckDoor.structure_pass_status = 'Pass';
                this.doorCheckDoor.signage_pass_status = 'Pass';
                this.doorCheckDoor.gaps_pass_status = 'Pass';
            },
            markAllAsNa() {
                this.doorCheckDoor.frame_pass_status = 'N/A';
                this.doorCheckDoor.hinge_pass_status = 'N/A';
                this.doorCheckDoor.lock_pass_status = 'N/A';
                this.doorCheckDoor.glass_pass_status = 'N/A';
                this.doorCheckDoor.seals_pass_status = 'N/A';
                this.doorCheckDoor.closer_pass_status = 'N/A';
                this.doorCheckDoor.structure_pass_status = 'N/A';
                this.doorCheckDoor.signage_pass_status = 'N/A';
                this.doorCheckDoor.gaps_pass_status = 'N/A';
            },
            markAllAsFail() {
                this.doorCheckDoor.frame_pass_status = 'Fail';
                this.doorCheckDoor.hinge_pass_status = 'Fail';
                this.doorCheckDoor.lock_pass_status = 'Fail';
                this.doorCheckDoor.glass_pass_status = 'Fail';
                this.doorCheckDoor.seals_pass_status = 'Fail';
                this.doorCheckDoor.closer_pass_status = 'Fail';
                this.doorCheckDoor.structure_pass_status = 'Fail';
                this.doorCheckDoor.signage_pass_status = 'Fail';
                this.doorCheckDoor.gaps_pass_status = 'Fail';
            },
            updateMarker(marker) {  
                this.doorCheckDoor.site_plan_image_position_x = marker.x;
                this.doorCheckDoor.site_plan_image_position_y = marker.y;
            },
        },
        mounted () {
            console.log('Called DoorCheckDoorAdd mount()');

            const modulesData = this.$session.get('enabled_modules');
            if(!modulesData || modulesData.indexOf('FDR') === -1) {
                this.$router.push('/');
                return;
            }

            this.getDoorSets();
            this.getDoorTypes();
            this.getClientDefinedRatings();
            this.getLocations();
            this.getSubstrateTypes();
            this.getDoorMaterials();
            this.getFrameMaterials();
            this.getDeclaredResistanceLevels();
            this.getLevelOptions();
            this.getDoorFaults();

            this.dropOptions.url = this.cmsUrl + 'api/v1/door-check-doors/upload-image';
            if (this.$route.name === 'door-check-edit-door') {
                this.isEdit = true;
            }
            
            if (!this.isEdit) {
                this.getDoorCheck(true);
                this.getDefaultInspectorNotes();
            } else {
                this.getDoorCheckDoor();
            }
        },
        computed: {
            allSelectedFaults() {
                let faults = [];
                if(this.doorCheck.is_third_party_report) {
                    if(this.frameFaults) {
                        faults = this.frameFaults;
                    }
                    if(this.hingeFaults) {
                        faults = [...faults, ...this.hingeFaults];
                    }
                    if(this.lockFaults) {
                        faults = [...faults, ...this.lockFaults];
                    }
                    if(this.glassFaults) {
                        faults = [...faults, ...this.glassFaults];
                    }
                    if(this.sealFaults) {
                        faults = [...faults, ...this.sealFaults];
                    }
                    if(this.closerFaults) {
                        faults = [...faults, ...this.closerFaults];
                    }
                    if(this.structureFaults) {
                        faults = [...faults, ...this.structureFaults];
                    }
                    if(this.signageFaults) {
                        faults = [...faults, ...this.signageFaults];
                    }
                    if(this.gapFaults) {
                        faults = [...faults, ...this.gapFaults];
                    }
                } else {
                    if(this.doorCheckDoor.frame_faults) {
                        faults = this.doorCheckDoor.frame_faults;
                    }
                    if(this.doorCheckDoor.hinge_faults) {
                        faults = [...faults, ...this.doorCheckDoor.hinge_faults];
                    }
                    if(this.doorCheckDoor.lock_faults) {
                        faults = [...faults, ...this.doorCheckDoor.lock_faults];
                    }
                    if(this.doorCheckDoor.glass_faults) {
                        faults = [...faults, ...this.doorCheckDoor.glass_faults];
                    }
                    if(this.doorCheckDoor.seals_faults) {
                        faults = [...faults, ...this.doorCheckDoor.seals_faults];
                    }
                    if(this.doorCheckDoor.closer_faults) {
                        faults = [...faults, ...this.doorCheckDoor.closer_faults];
                    }
                    if(this.doorCheckDoor.structure_faults) {
                        faults = [...faults, ...this.doorCheckDoor.structure_faults];
                    }
                    if(this.doorCheckDoor.signage_faults) {
                        faults = [...faults, ...this.doorCheckDoor.signage_faults];
                    }
                    if(this.doorCheckDoor.gaps_faults) {
                        faults = [...faults, ...this.doorCheckDoor.gaps_faults];
                    }
                }
                return faults;
            },
            areGlazingPanelsFieldsRequired() {
                return this.doorCheckDoor.glazing_panels;
            },
            areGapsFieldsRequired() {
                return this.doorCheckDoor.door_type !== 'Exit Door' && !this.doorCheck.is_third_party_report;
            },
            isSitePlanPositionRequired() {
                return this.selectedSitePlanImg;
            },
            locationNamesArray() {
                var locationNames = [];
                this.locations.forEach(function (entry) {
                    locationNames.push(entry.location_name);
                });
                return locationNames;
            },
            doubleDoorSelected() {
                return this.doorCheckDoor.door_set == 'Double' || this.doorCheckDoor.door_set == 'Door With Half Panel' || this.doorCheckDoor.door_set == 'Door & Half Leaf';
            },
            singleDoorSelected() {
                return this.doorCheckDoor.door_set == 'Single' || this.doorCheckDoor.door_set == 'Half' || this.doorCheckDoor.door_set == 'Part Door';
            },
            substrateTypeNamesArray() {
                var substrateTypeNames = [];
                this.substrateTypes.forEach(function (entry) {
                    substrateTypeNames.push(entry.substrate_type_name);
                });
                return substrateTypeNames;
            },
            getDropzoneUrl() {
                this.dropOptions.url = this.cmsUrl + 'api/v1/door-check-doors/upload-image.json';
                this.dropOptions.headers = {Authorization: 'Bearer '+this.$session.get('user_token')};
            },
            sitePlanMarkerData() {
                if(!this.doorCheckDoor.site_plan_image_position_x || !this.doorCheckDoor.site_plan_image_position_y) {
                    return null;
                }

                return {
                    position_x: this.doorCheckDoor.site_plan_image_position_x,
                    position_y: this.doorCheckDoor.site_plan_image_position_y,
                    zoom: this.doorCheckDoor.site_plan_image_zoom_level !== undefined ? this.doorCheckDoor.site_plan_image_zoom_level : 1
                };
            },
            selectedSitePlanImg() {
                console.log('Selected Site Plan: ' + this.doorCheckDoor.site_door_check_site_plan_id);
                if(!this.doorCheckDoor.site_door_check_site_plan_id) {
                    return null;
                }

                var selectedSitePlan = this.sitePlans.find((sitePlan) => {
                    return sitePlan.site_door_check_site_plan_id == this.doorCheckDoor.site_door_check_site_plan_id;
                });

                console.log('Selected Site Plan: ' + JSON.stringify(selectedSitePlan));

                if(!selectedSitePlan) {
                    return null;
                }

                if(selectedSitePlan.offline_site_plan_image) {
                    return selectedSitePlan.offline_site_plan_image.data;
                }
                
                return selectedSitePlan.site_plan_image ? (this.cmsUrl + selectedSitePlan.site_plan_image) : null;
            },
            postInstallationImages() {
                var imgs = [];
                this.doorCheckDoor.offline_images.forEach(item => {
                    if(item.door_status === this.doorStatuses[1]) {
                        imgs.push(item);
                    }
                });
                return imgs;
            },
            auditImages() {
                var imgs = [];
                this.doorCheckDoor.offline_images.forEach(item => {
                    if(item.door_status === this.doorStatuses[2]) {
                        imgs.push(item);
                    }
                });
                return imgs;
            },
            surveyImages() {
                var imgs = [];
                this.doorCheckDoor.offline_images.forEach(item => {
                    if(item.door_status !== this.doorStatuses[1] && item.door_status !== this.doorStatuses[2]) {
                        imgs.push(item);
                    }
                });
                return imgs;
            }
        }
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
    form {
        margin-bottom: 2rem;
    }

    [class*='-message'] {
        font-weight: 500;
    }

    .has-error {
        border: 1px solid #d33c40;
    }

    .error-message {
        color: #d33c40;
    }

    .success-message {
        color: #32a95d;
    }

    .vdp-datepicker__calendar .selected {
        background: var(--primary-color) !important;
        color: #fff;
    }
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
        border: 1px solid var(--primary-color) !important;
    }
</style>